export default {
  loginComponent: {
    login: {
      login_text_sichern_connect: 'Ingresar con Sichern Connect',
      copyright: 'Copyright',
      rrhh: 'Recursos Humanos',
      logintext: 'Ingresar',
      loadingtext: 'Cargando',
      forgetPassword: '¿Olvidó su contraseña?',
      commercialInfo: 'Información comercial',
      termsAndConditions: 'Políticas de Privacidad',
      help: '¿Necesitás ayuda?',
      helpTitle: 'Ayuda',
      helpFaq1: 'No puedo acceder a la plataforma para ver mi recibo',
      helpAnswer11:
        'SICHERN.COM permite una autogestión, mediante la opción "olvidé mi clave de acceso".',
      helpAnswer12:
        'El sistema enviará al correo electrónico registrado en el sistema las indicaciones para regenerar clave de ingreso o clave de firma.',
      helpAnswer13:
        'En caso que no te llegue el mail para restablecerla, debes ponerte en contacto con el departamento de Recursos Humanos de tu Empresa quienes podrás asistirte para recuperarla.',
      helpFaq2: '¿Cómo puedo desbloquear el usuario?',
      helpAnswer21:
        'Luego de varios intentos fallidos para ingresar a la plataforma, por seguridad, el sistema bloqueará el usuario.',
      helpAnswer22:
        'Para desbloquearlo simplemente debes ingresar a la opción "Olvidó su contraseña" e ingresar el mail registrado en el sistema y su DNI. ',
      helpAnswer23:
        'En caso de no poder restablecerlo debe ponerse en contacto con departamento de Recursos Humanos de tu Empresa quienes podrás asistirte para desbloquear el usuario',
      helpFaq3: '¿Es seguro el sistema?',
      helpAnswer3:
        'Sí, el mismo ha sido testeado con los mas rigurosos métodos de seguridad informática, y la comunicación se realiza de manera encriptada utilizando el protocolo https, el mismo utilizado por los bancos, tarjetas de crédito, sitios de pagos por Internet, etc.',
      requireMoreCharactersPass: 'La contraseña debe tener más de 4 caracteres',
      helpFaq4: '¿No puedo acceder a mi correo electrónico?',
      helpAnswer41: 'los correos de usuarios son administrados por la empresa.',
      helpAnswer42:
        'En caso de tener algún inconveniente o no poder ingresar, tienes que ponerte en contacto con el departamento de recursos humanos.',
      helpFaq5: '¿Qué pasa si no recuerdo mi contraseña?',
      helpAnswer51:
        'Si olvidaste tu contraseña, puedes restablecerla de forma rápida y segura.',
      helpAnswer52: 'Ingresá en la opción ¿Olvidaste tu contraseña?',
      helpAnswer53: 'Escribí el email y usuario registrado en Sichern.',
      helpAnswer54:
        'Recibirás un email con un link para poder restablecer tu contraseña.',
      helpAnswer55:
        'Una vez configurada tu nueva contraseña, tu usuario será desbloqueado y podrás ingresar a tu cuenta sin inconvenientes.',
      helpAnswer56:
        'En caso de no poder Restablecerla tienes que ponerte en contacto con Recursos Humanos de tu Empresa quienes podrán asistirte para desbloquear el usuario.',
      helpAnswer511:
        'tu usuario es tu documento de identidad (DNI, RFC, RUC, CI, etc).',
      helpAnswer522:
        'En caso de no poder ingresar, tienes que ponerte en contacto con',
      helpAnswer533: 'indicando el problema y enviando tu número de documento.',
      helpAnswer544:
        'O si prefieres puedes desde la pantalla de inicio de sesión ir a la opción ¿Olvidó su contraseña?',
      helpFaq6: '¿Cómo ingreso a mi cuenta?',
      helpAnswer61:
        'Ingresando tu usuario y contraseña registrados directamente desde',
      helpAnswer62:
        'Asegúrate de ingresar preferiblemente desde un navegador Chrome actualizado, bien sea por medio de un ordenador o desde tu   teléfono móvil.',
      helpAnswer63: 'También puedes ingresar desde nuestra APP mobile',
      helpAnswer64:
        'Importante: asegurate de tener nuestra versión más reciente',
      helpFaq7: '¿Cual es mi Usuario?',
      helpAnswer71:
        'En caso de no poder ingresar, tienes que ponerte en contacto con Recursos Humanos. indicando el problema y enviándonos tu número de documento.'
    },
    forgetPassword: {
      goBack: 'Volver al login',
      send: 'Enviar',
      mailResendMsg: 'No recibiste el email',
      mailResend: 'Reenviar email',
      passwordResetSuccess: 'Se ha enviado un mail con las instrucciones',
      err400ForgotPass:
        'No encontramos el usuario / email por favor verifica los datos ingresados '
    },
    forgetPasswordInvalid: {
      goBack: 'Volver',
      send: 'Ok',
      passwordResetFalse: 'La combinación de usuario y mail no es válida'
    },
    firstLogin: {
      firstLoginText: 'Primer ingreso',
      changePassSecurity:
        'Por razones de seguridad debe cambiar su clave de ingreso al sistema',
      rememberValidMail:
        'Recuerde ingresar un email válido, ya que será verificado durante el proceso',
      goBack: 'Volver al login',
      send: 'Enviar',
      success: 'La contraseña fue modificada con éxito',
      required: 'Este campo es requerido',
      notEmail: 'No poseo cuenta de email',
      accept: 'Acepto',
      termsAndConditions: 'Términos y condiciones',
      dataUpdated: 'Datos actualizados correctamente',
      enterMail: 'Ingresa tu Email',
      enterMailMessage:
        'Para mantener tu perfil actualizado es necesario que ingreses tu email',
      requiredMinCharactersAndOneNumber: 'Minimo 8 caracteres, 1 número',
      notPersonalInfo: 'No puede contener información personal del usuario',
      notEasyPassw:
        'La contraseña no debe ser sencilla (ej. 12345678, qwerty, admin1234, etc.)'
    },
    blockedUser: {
      title: 'Usuario bloqueado',
      mailResendMsg: 'No recibiste el email',
      mailResend: 'Reenviar email',
      msg_1: 'Por motivos de seguridad se ha bloqueado su usuario.',
      msg_3:
        'Te enviamos un mail a tu casilla de correo con los pasos a seguir.',
      msg_2:
        'Detectamos que no has podido recuperar tu contraseña.Te hemos enviado un correo electrónico con las instrucciones para la generación de la nueva contraseña.'
    },
    unblockedUser: {
      title: 'Usuario desbloqueado exitosamente',
      msg_1:
        'Su usuario se ha desbloqueado con éxito. Por favor intente nuevamente ingresar a la plataforma.'
    },
    validations: {
      emailRules: {
        requireMail: 'El email es requerido',
        validMail: 'El email debe ser válido',
        associatedMail: 'El Email ya está asociado a un usuario.'
      },
      userRules: {
        requireUser: 'El usuario es requerido',
        requireLessCharactersUser:
          'El usuario debe tener menos de 10 caracteres',
        charactersValidation:
          'El campo sólo permite caracteres alfanuméricos y guión bajo',
        minCharacters: 'El usuario debe tener al menos {min} caracteres'
      },
      reasonRules: 'El motivo es requerido',
      passwordRules: {
        requirePass: 'La contraseña es requerida',
        requireMoreCharactersPass:
          'La contraseña debe tener más de 8 caracteres'
      }
    },
    languagesVuetify: {
      languages: 'Lenguaje',
      user: 'Usuario',
      password: 'Contraseña',
      newPassword: 'Nueva clave',
      repeatPassword: 'Confirmar clave',
      inputMail: 'Ingrese su mail',
      mail: 'Email'
    },
    shutdownServer: {
      titleShutdown: 'No es posible acceder en este momento',
      subtitleShutdown: 'Por favor, inténtelo nuevamente más tarde'
    },
    sso: {
      textButton: 'Utilizar Single Sign-On',
      msgRedirectAuth: 'Autenticando...',
      msgRedirectLogin: 'Ingresando a Sichern',
      msgRedirectErrorLogin:
        'Ocurrio un error autentificando el usuario Intentelo nuevamente'
    },
    passwordExpired: {
      newPass: 'Contraseña',
      repeatPassword: 'Repetir contraseña',
      go_back_btn: 'Volver',
      go_to_dashboard: 'Ir al dashboard',
      update_pass_btn: 'Actualizar',
      pass_expired_message:
        'Tu contraseña expiró. Ingresa tu nueva contraseña.',
      message_error: {
        error_00019: 'La contraseña no cumple las políticas de la empresa',
        error_00024:
          'Hubo un problema al actualizar la contraseña, intente nuevamente',
        error_00026: 'No puede repetir las últimas 3 contraseñas',
        error_00033:
          'La nueva contraseña no puede ser igual a la contraseña actual',
        error_00141: 'La contraseña no cumple las políticas de la empresa',
        error_00046:
          'Ha realizado los cambios de contraseña máximos permitidos en el día. Su cuenta se restablecerá dentro de 24hs'
      },
      password_validation: {
        required: 'Este campo es requerido',
        no_match_pass: 'Las contraseñas ingresadas no coinciden',
        min_character_rule: 'Este campo debe contener al menos 8 caracteres',
        min_number_rule: 'Este campo debe contener al menos 1 número',
        min_character_info: 'Mínimo 8 caracteres, 1 número'
      },
      password_policies: {
        title: 'La contraseña debe contener:',
        history_pass: 'Distinta a las últimas {input} contraseñas',
        max_character: 'Máximo {input} caracteres',
        min_character: 'Mínimo {input} caracteres',
        no_expire: 'No expira',
        expire: 'Expira en {input} días',
        special_characters_amount: 'Al menos {input} caracteres especiales',
        min_numbers: 'Al menos {input} numero',
        min_capital_letter: 'Al menos {input} mayuscula',
        min_letter: 'Mínimo {input} letra(s)'
      },
      success: {
        success_message: 'Contraseña actualizada correctamente',
        pls_go_back: 'Por favor, intente volver a ingresar al sistema.',
        go_back_btn: 'Volver al login'
      }
    },
    keyCloak: {
      error: {
        title: 'Error al validar la cuenta',
        body1:
          'Podés intentarlo nuevamente en unos minutos o ingresa con tu usuario y contraseña de Sichern.',
        body2:
          'Si el problema continua, contacta al equipo de Recursos Humanos.',
        footer: 'Código de error: {errorCode}'
      },
      notLinked: {
        title: 'Tu cuenta de MiFalabella no está vinculada a Sichern',
        body:
          'Para continuar, vincula  tus cuentas. Solo necesitás hacerlo una vez y luego vas a poder acceder a Sichern desde MiFalabella. Ingresá a continuación tu usuario y contraseña de Sichern.'
      }
    },
    backToPreview: 'Volver',
    firstToKnow:
      'Para comenzar debes conocer todas las claves de tus cuentas. Si no las conoces, puedes revisar como'
  },
  inicioComponent: {
    hi: 'Hola',
    botText:
      '¡Hola, {user}!, Soy Vismi, tu asistente virtual y estoy aquí para ayudarte con Sichern de sueldo.',
    initialText1:
      'En "Tu Recibo" encontrarás todo lo relacionado con tu trabajo.',
    initialText2:
      'Podrás firmar tus recibos de sueldo, actualizar tu información personal y solicitar licencias',
    initialText3: ', todo desde aquí.',

    documentsToSign: 'Documentos a firmar',
    documentsAvailable: '{n} pendiente de firma | {n} pendientes de firma ',
    requestLicense: 'Vacaciones y licencias',
    licensesAvailable: '{n} día disponible | {n} días disponibles',
    licensesRegistered: '{n} día registrado | {n} días registrados',
    upload: 'Fotos, archivos y formularios',
    dashboard: {
      noDashboardTitle: 'Hoy no hay mensajes',
      noDashboardSubtitle:
        'En esta sección podrás encontrar novedades y noticias.',
      uploadNewNovelty: 'Cargar una novedad ahora'
    },
    failServer: 'Algo fallo en el servidor, intente más tarde.',
    createSince: 'Creado desde',
    createUntil: 'Creado hasta',
    notResults: 'No se encontraron los resultados para la busqueda',
    infoSearch:
      'Para realizar una búsqueda podes ingresa el Nombre, Apellido, Codigo de  identificación en los campo de búsqueda o seleccionar una combinación de filtros.',
    resultSearch: 'Los resultados de tu busqueda se mostraran aquí',
    advanceSearch: 'Búsqueda Avanzada',
    name: 'nombre',
    goto: 'Ir a',
    downloadSelected: 'Descargar Selección',
    downloading: 'Descargando...',
    anniversaryDate: '29 de enero',
    febraryDate: '11 de febrero',
    welcomeAgainMsg: 'Bienvenido nuevamente al portal de empleados',
    wecomeSichern: '¡Bienvenidos a la nueva web de Sichern!',
    newInterface: 'Nueva interfaz más intuitiva',
    newUI: 'Pantalla de inicio renovada',
    allDocuments: 'Todos tus documentos ordenados de forma más simple',
    number: 'numero',
    numbers: 'numeros',
    upperCase: 'mayuscula',
    upperCases: 'mayusculas',
    caracter: 'caracter especial',
    caracteres: 'caracteres especiales'
  },
  resetPassComponent: {
    title: 'Recupero de contraseña',
    subtitle: 'Se ha solicitado cambiar su clave de ingreso al sistema',
    labelNewPass: 'Ingrese una contraseña nueva',
    labelReNewPass: 'Reingrese la contraseña nueva',
    successTitle: 'Clave actualizada correctamente',
    successMsg: 'Por favor, intente volver a ingresar al sistema',
    successOkBtn: 'Volver al login',
    goBackLogin: 'Volver al login',
    mailSentRecover: 'Te enviamos un mail para recuperar tu contraseña',
    followStepsRecover:
      'Segui los pasos correspondientes en el email para poder generar una contraseña nueva',
    minimalPasswordPolicies: 'Minimo 8 caracteres, 1 número',
    recoverPassword: 'recuperar tu contraseña'
  },
  menuComponent: {
    item0: 'Inicio',
    item1: 'Documentos',
    item2: 'Solicitar',
    item3: 'Configuración',
    item4: 'Enviar',
    item5: 'Enviar documento',
    tasks: 'Bandeja de tareas',
    tasksShort: 'Bandeja',
    modalMessage: '¿Está seguro/a que desea cancelar la solicitud?',
    licences: {
      name: 'Vacaciones y Ausentismos',
      shortName: 'Ausentismos',
      upperCase: 'AUSENTES',
      lowerCase: 'Ausentes',
      loadLicense: 'Carga Licencia'
    },
    managerAd: 'administrador',
    myApps: 'Mis aplicaciones',
    sended: 'Envio',
    goToDashboard: 'Ir al administrador',
    manageAbs: 'Gestión de ausencias',
    weekDays: 'Domingo,Lunes,Martes,Miercoles,Jueves,Viernes,Sábado',
    seeMissing: 'Ver ausentes',
    presents: 'Presentes',
    back: 'Atras'
  },
  HeaderComponent: {
    logout: {
      wantLogOutText: '¿Está seguro/a que desea salir?',
      no: 'No',
      yes: 'Si'
    },
    filters: {
      filters: 'Filtros',
      close: 'Cerrar'
    },
    help: 'Ayuda',
    search: 'Buscar',
    apps: 'Aplicaciones',
    company: 'Empresa',
    notifications: 'Notificaciones',
    accountsLinked: 'Vincula tus cuentas',
    onlyOneAccount:
      'Puedes vincular todas tus cuentas y acceder a ellas desde una única cuenta principal.',
    goAccountsLinked: 'Ir a vincular cuentas',
    sichernTalent: 'Sichern Talent',
    sichernUnite: 'Sichern Unite',
    sichernTime: 'Sichern Time',
    timeManagement: 'Gestión de Tiempos',
    omitNotification:
      'Recuerda que siempre puedes retomar este proceso desde el ícono de notificaciones y si no quieres vincular, puedes omitirlo.',
    noMatchSearch: 'No hay colaborador que coincidan con tu busqueda',
    timePeriod: 'Período​ de tiempo',
    failedAgain: 'Algo fallo, intente nuevamente.',
    dates: 'La fecha de inicio y finalización no pueden ser iguales.',
    success: 'La información se envío correctamente y espera aprobación.'
  },
  DocumentsComponents: {
    title: 'Documentos',
    titleFilter: 'Filtros',
    alerts: {
      blockedDocument: 'Aceptar',
      cantVisualiceDoc: 'No podemos visualizar tu documento',
      dontPermissionDoc: 'No tienes permisos para visualizar este documento'
    },
    statusSigned: {
      signedConformed: 'FIRMADO CONFORME',
      signedDisconformed: 'FIRMADO DISCONFORME',
      pendingApproval: 'PENDIENTE APROBACION',
      noRequiredSignature: 'NO REQUIERE FIRMA',
      rejected: 'RECHAZADO',
      noSigned: 'NO FIRMADO'
    },
    searchDocuments: 'Buscador de Documentos',
    pdfFile: 'Archivo PDF',
    xmlFile: 'Archivo XML',
    filterBy: 'Filtrar por:',
    signedSince: 'Firmado desde',
    signedUntil: 'Firmado hasta',
    legal: 'Legales',
    progresive: 'Progresivos',
    documentSended: 'Documento Enviado',
    account: 'Cuenta Sueldo',
    ctsAccount: 'Cuenta CTS',
    failSaved: 'Hubo un error al procesar el guardado',
    previewDocument: 'Vista previa del documento',
    fileTitle: 'Archivo',
    connectorFile: 'en total'
  },
  DownloadAllDocuments: {
    downloadAll: 'Descargar',
    downloadAllDocuments: 'Descargar Todo',
    downloadDocuments: 'Descargar Documentos',
    preparingDocuments: 'Estamos preparando tus documentos',
    sendYouMail: 'Te enviaremos un mail para descargarlo',
    youWantDownloadAllDocs: '¿Quieres descargar todos los,',
    selectedDocuments: 'documentos?',
    sendToLinkMail: 'Te enviaremos un link de descarga al siguiente mail',
    messageWarning:
      'Recomendamos que sea un email personal. Al ingresar a la plataforma, le vamos a solicitar las credenciales.',
    messageWarningNoEmail:
      'No tienes un email registrado para continuar con la descarga, registralo desde tu perfil',
    sendToLinkMailInMinutes:
      'Recibiras un link para descargarlos en los próximos minutos en tu email',
    cancel: 'Cancelar',
    yesDownload: 'Si, descargar',
    understood: 'Entendido',
    downloadInProgress: 'Se encuentra en proceso una descarga.',
    pleaseTryAgain: 'Vuelva a intentar en unos instantes.',
    discardDownload: '¿Desea descartarla y realizar una nueva descarga?',
    downloadModal: {
      title: 'Descarga de documentos',
      titleChangeCompany: 'Cambio de empresa',
      messageInitialDownload:
        'La descarga de documentos se inició de manera automática.',
      problemWithDownloadLink: 'Si tienes problemas con la descarga',
      clickHere: 'haz click aquí',
      expiredDownload: 'La descarga de tus documentos expiro',
      retryDownload: 'Si quieres reintentar descargarlos',
      iframeRetryDownload:
        'Vuelve a intentarlo, haciendo clic nuevamente en el botón Descargar',
      messageRedirect:
        'Te estamos redirigiendo a la siguiente empresa por favor aguarda unos instantes'
    }
  },
  homeComponent: {
    title: 'Home',
    sections: {
      documents_to_sign: 'Documentos a firmar',
      send_signed_document: 'Envío de documento firmado',
      send_document_email: 'Enviar documento por mail',
      valid_email_requerid: 'El mail es requerido y debe ser válido',
      send_valid_email:
        'Al firmar estaras enviando a la casilla de mail seleccionada el documento',

      vacations_licenses: 'Vacaciones y Ausentismos',
      documentsManagement: 'Gestión de documentos',
      upload_file: 'Enviar documento',
      self_service: 'Actualización de datos',
      eform_complete: 'Completar Formulario',
      subtitles: {
        sub_documents_sing: 'Ir a mis documentos',
        sub_vacations_licences: 'Ir a mis licencias',
        sub_self_service: 'Modifica tus datos en la plataforma',
        documentsManagement: 'Envío y solicitud de documentación'
      }
    },
    homeContents: {
      title: 'Firma de recibos de sueldo',
      next_page: 'Página siguiente',
      prev_page: 'Página anterior'
    },
    birthdays: {
      title: 'Cumpleaños',
      no_events: 'Sin eventos',
      before_yesterday: 'Ante ayer',
      yesterday: 'Ayer',
      today: 'Hoy',
      tomorrow: 'Mañana',
      after_tomorrow: 'Pasado mañana',
      next: 'Próximos'
    },
    recentHired: {
      title: 'Ingresos del mes',
      no_events: 'No hay ingresos este mes',
      show_more: 'Mostrar más',
      show_minus: 'Mostrar menos',
      teammate: 'Compañeros de equipo'
    },
    absentUsers: {
      title: 'Ausencias',
      emptyMessage: 'No hay ausencias en tu sector el día de hoy'
    },
    anniversaries: {
      title: 'Aniversarios'
    },
    linkUserLogin: {
      title: 'Vinculación de cuentas',
      error: 'Hubo un error inesperado, intente nuevamente',
      byEmail: {
        subtitle: 'Actualización de email',
        info:
          'Estas a punto de vincular las cuentas con este email <strong>{mail}</strong> <br/> ¿Quieres continuar?',
        ok: 'Si, vincular cuentas',
        cancel: 'Cancelar',
        success_message:
          'Email actualizado correctamente<br/>Las cuentas han sido vinculadas',
        success_message_2: 'Por favor, intente volver a ingresar al sistema',
        go_login: 'Volver al login',
        finish: 'Vinculacion finalizada',
        no_success:
          'No se va a vincular ninguna cuenta, que tenga un buen dia.',
        redirect_home: 'Se redigira al home'
      },
      byPass: {
        subtitle: 'Nueva contraseña',
        info:
          'Para continuar con la vinculación de cuentas, es necesario que crees una nueva contraseña',
        newPass: 'Nueva contraseña',
        repeatPass: 'Repite contraseña',
        successMessage:
          'Actualizaste tu contraseña<br/>Las cuentas han sido vinculadas'
      },
      tokenExpired: {
        info_1: 'Expiró la solicitud para vincular las cuentas',
        info_2: 'Por favor, ingrese al sistema para generar otra',
        go_login: 'Ingresar'
      }
    },
    linkUserModals: {
      later: 'En otro momento',
      title: 'Vincular cuentas',
      ok: 'Entendido',
      byPassword: {
        title:
          'Detectamos que tienes otra cuenta asociada a éste email. ¿Quieres unificarlas?',
        subtitle_1:
          'Al presionar el botón “Vincular cuenta” enviaremos un email a <strong>{mail}</strong> para que inicies la vinculación',
        subtitle_2:
          'Para vincular las cuentas, vamos a pedirle que generes una contraseña nueva',
        usersToLink: 'Cuentas a vincular',
        linkAccount: 'Vincular cuenta',
        mailSent: 'Mail enviado',
        mailSentMessage:
          'Enviamos un mail a {mail} para continuar con los datos para vincular de tu cuenta.',
        resendMail: 'Reenviar email'
      },
      byEmail: {
        step1: {
          title:
            'Detectamos que tu usuario tiene cuentas que se pueden vincular',
          subtitle_1: '¿Quieres vincular tu usuario con esta empresa?',
          info:
            'Al vincular las cuentas, tu usuario y contraseña para acceder a la plataforma va a ser el mismo y eso te facilitara el acceso a las distintas empresas en las que te desempeñaste. Podrás ingresar a una empresa u otra con las mismas credenciales.',
          linkAccount: 'Vincular cuenta'
        },
        step2: {
          subtitle_1:
            'Seleccioná un mail para establecerlo como predeterminado para acceder al sistema',
          subtitle_2:
            'Te enviaremos un email a <strong>{mail}</strong> para que puedas confirmar la vinculación de cuentas',
          sendEmail: 'Enviar email'
        },
        success: {
          title: 'Vinculación de cuentas',
          subtitle_1:
            'Te enviamos un email a tu cuenta <strong>{mail}</strong> para que finalices la vinculación',
          subtitle_2: 'Si no recibiste el email ',
          resendEmail: 'Reenviar email'
        }
      }
    },
    downloadLinkMobile: {
      availableApp:
        'Tenemos una nueva actualización de la app de tu recibo disponible.',
      authMessage:
        'Ahora podrás iniciar sesión en Sichern usando la huella o el rostro si tu dispositivo lo permite.',
      download: 'Download on the',
      appStore: 'App Store',
      getIt: 'GET IT ON',
      googlePlay: 'Google Play'
    },
     alert: {
        falabella: {
          fail: {
            title: 'Hubo un inconveniente al vincular las cuentas.',
            subtitle:
              'Podés intentarlo nuevamente en unos minutos. Si el problema continúa, contacta al equipo de Recursos Humanos.'
          },
          success: {
            title: 'Cuenta vinculada con éxito',
            subtitle:
              'Ahora podrás ingresar a sichern desde tu cuenta de mi Mifalabella'
          }
        }
      },
    delete: 'Borrar',
    selected: 'seleccionados',
    deleteSelected: 'Borrar {lngt} seleccionados',
    visualizacionHere: 'Aquí se visualizaran',
    allTxt: {
      allTxt1: 'Todos los',
      allTxt2: 'Todas las'
    },
    addeds: {
      addeds1: 'agregados',
      addeds2: 'agregadas'
    },
    allAddeds1: 'Todos los {dni} agregados',
    allAddeds2: 'Todas las {cis} agregadas',
    sector: 'Sectores',
    location: 'Locaciones',
    noForm: 'No hay formularios disponibles para autogestión',
    men: 'Hombre',
    women: 'Mujer',
    noBinary: 'No Binario'
  },
  searchComponent: {
    sections: {
      title: 'Buscador de empleados'
    },
    download: {
      text_filter_by_page: 'Mostrar',
      employee_export_results: 'Exportar Resultados',
      employee_exporting_results: 'Exportando...'
    },
    alerts: {
      modal_reset_pass_correct: 'Mail Enviado',
      modal_reset_pass_incorrect: 'Error al enviar mail',
      modal_reset_pass_incorrect_change: 'Error al cambiar el mail',
      button_confirm: 'Aceptar'
    },
    advanceSearch: {
      text_sector: 'Sector',
      text_locacion: 'Locación',
      all_locacion: 'TODOS',
      all_sector: 'TODOS'
    },
    title: 'Buscador',
    search: 'Criterios de búsqueda',
    form_select: 'Seleccione...',
    not_founded: 'No encontrado',
    max_elements: 'Máximo un elemento seleccionado',
    employee_result: 'Resultados',
    employees_list_result: 'Lista de empleados',
    employees_title: 'Gestión de empleados',
    employees_list_search_title_error: '¡Esto es un desierto!',
    employees_list_search_desc_error:
      'Lo sentimos, pero no encontramos ningún resultado con los criterios de búsqueda seleccionados. Por favor intente con una combinación distinta.',
    employees_list_search_title:
      'Los resultados de su búsqueda se mostrarán aquí',
    employees_list_search_desc:
      'Para realizar una búsqueda puede ingresar el Nombre, Apellido, Documento de identidad o Email del empleado en el campo de búsqueda o seleccionar una combinación de filtros.',
    searchfor: 'Buscar',
    ob_load_employees: 'Carga de empleado',
    home_button_add: 'Administrar Empleados',
    ob_masive_load_employees: 'Carga masiva de empleados',
    search_text_select_cargo: 'TODOS',
    search_text_1: 'Búsqueda por:',
    search_text_1_1: 'Documento de identidad, Nombre, Apellido o Email',
    search_text_1_2: 'Legajo',
    search_text_1_3: 'Búsqueda Avanzada',
    search_text_2: 'Estado Empleado',
    search_text_2_1: 'Onboarding',
    search_text_2_2: 'Activo',
    search_text_2_3: 'Inactivo',
    search_text_3: 'Tipo de Perfil',
    search_text_3_1: 'RRHH',
    search_text_3_2: 'Empleado',
    search_text_6: 'Módulo de Licencias',
    search_text_6_1: 'Aprobador',
    search_text_7: 'Ingreso',
    search_text_7_1: 'No ingresaron',
    search_text_8: 'Sector y Locación',
    search_text_9: 'Seleccionado',
    search_text_10: 'Fecha de contratación',
    search_text_11: 'Fecha de desvinculación',
    search_text_date_placeholder: 'Selecione un rango de fecha',
    search_folder_tooltip: 'Configurar carpetas',
    search_reset_pass_tooltip: 'Restablecer clave',
    fileNumber: 'Número de legajo',
    fileNumberInvalid: 'Valor invalido, campo numérico',
    listEmployees: {
      ob_down_employees: 'Baja masiva',
      tooltip_cargo:
        'Puesto que desarrolla el empleado en la compañía. Actualizable de forma masiva por CSV en "Carga masiva" o de forma individual en el detalle del empleado',
      tooltip_report:
        'Jefe directo.  Actualizable de forma masiva por CSV en "Carga masiva" o de forma individual en el "Legajo del empleado"'
    },
    head_text_table_list_1: 'Nombre',
    head_text_table_list_2: 'Ultima modificación',
    head_text_table_list_3: 'Estado',
    head_text_table_search_1: 'Nombre y Apellido',
    head_text_table_search_2: 'Email',
    head_text_table_search_3: 'Documento de identidad',
    head_text_table_search_4: 'Legajo',
    head_text_table_search_5: 'Estado',
    head_text_table_search_6: 'Fecha de contratación',
    text_table_status_1: 'Activar',
    text_table_status_2: 'Desactivar',
    onboarding_label_by_page: 'Mostrar',
    employees_list_modal_reset_subtitle:
      'Se enviará un link al usuario para reestablecer la contraseña',
    employee_export_results: 'Exportar Resultados',
    employee_exporting_results: 'Exportando...',
    employee_activate_selection: 'Activar Selección',
    employee_confirm: 'Aceptar',
    employee_edit_error: 'Algo falló!',
    employee_edit_success: 'Usuario modificado exitosamente',
    employees_list_modal_folder_title: 'Permisos a carpetas',
    search_folder_placeholder: 'No hay más carpetas',
    employees_list_modal_folder_empty: 'No hay carpetas asignadas',
    header_top_bar_modal_save: 'Guardar',
    employees_list_modal_folder_subtitle: 'Carpetas asignadas',
    cancel: 'Cancelar',
    login_send: 'Enviar',
    ei_titleList_text_2_2: 'Email',
    position_position_ubication: 'Cargo',
    report_to_position_ubication: 'Reporta a',
    error_position_not_found: 'Cargo no disponible',
    select_folders: 'Seleccionar carpetas',
    select_location: 'Seleccione un sector',
    select_position: 'Seleccione un cargo',
    select_section: 'Seleccione una locación',
    search_combo_reporta_a: 'Realice una búsqueda...',
    empty_list: 'Lista vacia',
    show_password: 'Mostrar contraseña',
    select_options: 'Seleccione una opción',
    load_photo: 'Subir foto'
  },
  Errors: {
    401: {
      title_401: 'No posee autorización',
      sub_title_401: 'Su sesión ha caducado. Debe iniciarla nuevamente'
    },
    403: {
      title_403: 'Lo sentimos, pero usted no tiene acceso a esta página.',
      sub_title_403:
        'Si usted no es administrador puede ir al sitio de empleado o volver al inicio.'
    },
    404: {
      title_404: 'Lo sentimos, pero la página no fue encontrada',
      sub_title_404: 'Afortunadamente usted puede volver a buscar en el inicio'
    },
    500: {
      title_500: 'No se ha podido generar el token'
    },
    rrhhHandler: {
      notPermission: 'No tienes permisos para acceder a esta sección',
      buttonGoToAdmin: 'Ir al administrador de RRHH'
    }
  },
  errorReference: {
    SICHERN_PEOPLE_EMPLOYEE_CONFLICT:'Hemos detectado usuarios duplicados en Sichern People. Por favor contáctese con su administrador.',
    SICHERN_PEOPLE_NOT_IMPLEMENTED:'Esta funcionalidad no está disponible desde Sichern People.',
    SICHERN_PEOPLE_EMPLOYEE_NOT_EXISTS:'No hemos podido encontrarte como empleado en Sichern People. Por favor contáctese con su administrador.',
    SICHERN_PEOPLE_GET_PAYROLL_IN_ADVANCE_PERIOD_REQUESTED_NOT_FOUND: 'El período de nómina por adelantado no se encontró para la fecha solicitada',
    SICHERN_PEOPLE_GET_HOLIDAYS_MODEL_NOT_FOUND: 'El empleado no tiene configurado un modelo de vacaciones. Por favor contáctese con soporte.',
    SICHERN_PEOPLE_GET_HOLIDAYS_BALANCE_NOT_FOUND: 'El empleado no tiene configurado vacaciones.',
    SICHERN_PEOPLE_GET_ABSENCE_MODEL_NOT_FOUND: 'El empleado no tiene configurado un modelo de ausencias. Por favor contáctese con soporte.',
    SICHERN_PEOPLE_GET_ABSENCE_BALANCE_NOT_FOUND: 'No se encuentra el balance para esta licencia. Por favor contacte con el administrador de Sichern People o soporte.',
    SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_BAD_REQUEST_AbsenceNotExists:'No se pudo encontrar la licencia en Sichern People, contáctese con su administrador.',
    SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_ERROR:'No se pudo procesar la solicitud en este momento, inténtelo más tarde.',
    SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_BAD_REQUEST:'Hubo un incoveniente al procesar la solicitud.',
    SICHERN_PEOPLE_PUT_APPROVE_ABSENCE_BAD_REQUEST_StatusNotAllowed:'La licencia ya fue procesada.',
    SICHERN_PEOPLE_PUT_REJECT_ABSENCE_NOT_FOUND:'No se pudo encontrar la licencia en Sichern People, contáctese con su administrador.',
    SICHERN_PEOPLE_PUT_REJECT_ABSENCE_ERROR:'No se pudo procesar la solicitud en este momento, inténtelo mas tarde.',
    SICHERN_PEOPLE_PUT_REJECT_ABSENCE_BAD_REQUEST:'Hubo un incoveniente al procesar la solicitud.',
    SICHERN_PEOPLE_PUT_REJECT_ABSENCE_BAD_REQUEST_StatusNotAllowed:'La licencia ya fue procesada.',
    SICHERN_PEOPLE_HOLIDAYS_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST:'No se puede procesar la solicitud porque estás intentando solicitar más días de los disponibles.',
    SICHERN_PEOPLE_HOLIDAYS_REQUEST_ERROR_IN_START_DATE_BeginningOfAbsenceOnAHoliday: 'El día de inicio de la licencia no es válido. ',
    SICHERN_PEOPLE_HOLIDAYS_REQUEST_ERROR_IN_END_DATE_EndOfAbsenceOnAHoliday: 'El día de fin de la licencia no es válido',
    SICHERN_PEOPLE_HOLIDAYS_NUMBER_OF_DAYS_TO_REQUEST_IS_NOT_MULTIPLE_OF_BAD_REQUEST_RequestedDaysIsNotMultipleOf: 'La cantidad de dias solicitados no son múltiplo de: {errorValue}',
    SICHERN_PEOPLE_HOLIDAYS_REQUEST_ERROR_IN_START_DATE: 'El día de inicio de la licencia no es válido.',
    SICHERN_PEOPLE_HOLIDAYS_REQUEST_ERROR_IN_END_DATE: 'El día de fin de la licencia no es válido',    
    SICHERN_PEOPLE_DATE_MISMATCH:'Las fechas seleccionadas coinciden con días feriados no disponibles. Por favor, modifica el inicio y/o el final del periodo de licencia.',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST_AnnualQuotaNotValid:'La cantidad de días solicitados supera el tope anual.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AntiqueCountNotValid:'La fecha de inicio supera el límite de antigüedad de carga permitido para este tipo de ausencia.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_DaysOverlapExists:'Se detectó otra ausencia entre las fechas de la solicitud.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AbsenceTypeNotAllowed:'El tipo de ausencia seleccionada no es válida.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_invalidDatesForPartialAbsence:'Rango de fechas inválidas para ausencia parcial. Debe iniciar y finalizar el mismo dia',
    SICHERN_PEOPLE_POST_BAD_REQUEST_InvalidDateRange:'Las fechas ingresadas no son válidas',
    SICHERN_PEOPLE_POST_BAD_REQUEST_NumberOfHoursIsInvalid:'Rango de horas es inválida para ausencia parcial.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_PartialAbsenceNotSupported:'No se permite el uso de ausencia parcial.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_OrganizationModelNotFound:'El usuario no cuenta con un modelo organizacional en Sichern People.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_ProcessedAbsenceExists:'¡Atención! Esta ausencia fue procesada. No se permite modificar o eliminar.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AbsenceStatusNotValidForOperation:'La acción no se puede realizar por el estado actual de la ausencia.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_RequestedDaysIsNotMultipleOf: 'La cantidad de dias solicitados, no cumple con el múltiplo requerido',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AbsenceTypeNotValidForContinuity:'El tipo de ausencia no es elegible para continuidad.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AbsenceTypeIsNotActive:'El tipo de ausencia no se encuentra activa. Consulte con la administración.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_InvalidAtrributes:'Se detectaron atributos inválidos en la solicitud, por favor contacte con el administrador de Sichern Poeple.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_GenderNotValid:'La ausencia seleccionada no está disponible según el género del colaborador.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_EventsMaxNumberNotValid: 'Esta licencia superó la cantidad de solicitudes máximas permitidas según política',
    SICHERN_PEOPLE_POST_BAD_REQUEST_MonthlyQuotaNotValid: 'No se puede generar la solicitud, has excedido la cantidad de solicitudes en el mes.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_WorkSeniorityNotValid: 'No se puede solicitar esta ausencia, ya que el usuario no cumple con la antigüedad mínima requerida.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_ErrorCreatingReviewStatus:'Falló la solicitud, no fue posible generar la situación de revista para esta ausencia.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_DateFromMondayNotValid:'La solicitud debe iniciar un día Lunes',
    SICHERN_PEOPLE_POST_BAD_REQUEST_MinimumNumberOfDaysNotValid:'No se puede procesar la solicitud ya que no cumple con el mínimo de días requerido por política.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_ExtendPeriodNotValid: "La fecha de fin de la solicitud debe ser anterior, ya que se supera la cantidad de meses de extensión del período permitida, según la configuración del modelo de vacaciones.",
    SICHERN_PEOPLE_POST_BAD_REQUEST_CertificateIsRequired:'El certificado es obligatorio para solicitar esta ausencia.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_BeginningOfAbsenceOnAHoliday: 'La solicitud comienza en día feriado, debes solicitarla un día posterior.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_AntiqueCountNotValid:'La fecha de inicio supera el límite de antigüedad de carga permitido para este tipo de ausencia.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_begginingOfAbsenceOnAHoliday:'La ausencia no puede iniciar un día feriado, podrá iniciar a partir del próximo día hábil.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_DateFromMondayNotValid:'La solicitud debe iniciar un día Lunes',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_DaysOverlapExists:'Se detectó otra ausencia entre las fechas de la solicitud.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_MinimumNumberOfDaysNotValid:'No se puede procesar la solicitud ya que no cumple con el mínimo de días requerido por política.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_BeginningOfAbsenceOnAHoliday: 'No se puede iniciar la ausencia en dia feriado/festivo',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_AnticipatePeriodNotValid: 'El periodo anticipado no es valido.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_InsufficientBalanceError: 'Saldo insuficiente. El saldo cuenta con días vencidos.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_RequestStartDayNotAllowed: 'El día de inicio de la licencia no es válido.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_RequestEndDayNotAllowed: 'El día de fin de la licencia no es válido.',
    SICHERN_PEOPLE_POST_HOLIDAYS_BAD_REQUEST_NumberOfDaysRequestByLimitNotValid: 'No se puede procesar la solicitud porque estás intentando solicitar más días de los disponibles.',
    SICHERN_PEOPLE_POST_HOLIDAYS_ERROR:'Error al momento de solicitar esta licencia. Por favor contáctese con soporte.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_MaternityAbsenceNotFound: 'No se puede solicitar una licencia por excedencia ya que no existe una licencia por maternidad previa registrada',
    SICHERN_PEOPLE_POST_BAD_REQUEST_InvalidIdCertificate: 'No se puede solicitar la licencia con archivo adjunto. El identificador del archivo es inválido para Sichern People.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_AbsenceTotalDaysExceedsEventsMaxNumber:'La cantidad de días solicitados supera el máximo permitido por ausencia.',
    SICHERN_PEOPLE_POST_BAD_REQUEST_InsufficientBalanceError:'No tiene suficiente saldo para pedir la solicitud.',
    SICHERN_PEOPLE_ABSENCE_NUMBER_OF_DAYS_TO_REQUEST_BAD_REQUEST: 'No fue posible calcular el número de días a descontar. Por favor contáctese con soporte.',
    SICHERN_PEOPLE_ABSENCE_NUMBER_OF_DAYS_TO_REQUEST_ERROR:'Error al calcular el número de días a descontar. Por favor contáctese con soporte.',
    SICHERN_PEOPLE_HOLIDAYS_NUMBER_OF_DAYS_TO_REQUEST_ERROR:'Error al calcular el número de días a descontar. Por favor contáctese con soporte.',
    SICHERN_PEOPLE_POST_ABSENCE_ERROR:'Error al momento de solicitar esta licencia. Por favor contáctese con soporte.',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST:'Hubo un inconveniente al procesar la solicitud',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST_DaysOverlapExists: 'Se detectó otra ausencia entre las fechas de la solicitud.',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST_AbsenceTotalDaysExceedsEventsMaxNumber:'La cantidad de días solicitados supera el máximo permitido por ausencia.',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST_AntiqueCountNotValid:'La fecha de inicio supera el límite de antigüedad de carga permitido para este tipo de ausencia.',
    SICHERN_PEOPLE_POST_ABSENCE_BAD_REQUEST_MonthlyQuotaNotValid: 'No se puede generar la solicitud, has excedido la cantidad de solicitudes en el mes.',
    SICHERN_PEOPLE_PUT_APPROVE_HOLIDAYS_ERROR:'No se pudo procesar la solicitud en este momento , inténtelo más tarde.',
    SICHERN_PEOPLE_PUT_APPROVE_HOLIDAYS_NOT_FOUND:'No se pudo encontrar la licencia en Sichern People , contacte con su administrador.',
    SICHERN_PEOPLE_PUT_APPROVE_HOLIDAYS_BAD_REQUEST:'Hubo un inconveniente al procesar la solicitud',
    SICHERN_PEOPLE_PUT_APPROVE_HOLIDAYS_BAD_REQUEST_StatusNotAllowed:'La licencia ya fue procesada',
    SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_NOT_FOUND:'No se pudo encontrar la licencia en Sichern People, contáctese con su administrador.',
    SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_ERROR:'No se pudo procesar la solicitud en este momento, inténtelo mas tarde.',
    SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_BAD_REQUEST:'Hubo un incoveniente al procesar la solicitud.',
    SICHERN_PEOPLE_PUT_REJECT_HOLIDAYS_BAD_REQUEST_StatusNotAllowed:'La licencia ya fue procesada.',
    SICHERN_PEOPLE_GET_HOLIDAYS_TIME_REGIME_NOT_FOUND:'El empleado no tiene asignado un régimen de tiempo.',
    SICHERN_PEOPLE_POST_UPLOAD_FILE_ERROR:'No se puede solicitar la licencia con archivo adjunto. No fue posible enviar el archivo a Sichern People',
    SICHERN_PEOPLE_POST_UPLOAD_FILE_CREATION_ERROR: 'No se puede solicitar la licencia con archivo adjunto. No fue posible crear el archivo y enviarlo a Sichern People',
    SICHERN_PEOPLE_POST_SALARY_IN_ADVANCE_BAD_REQUEST_PeriodDiscountIdNotFound: 'Debe existir el Id del período de nómina para el descuento',
    SICHERN_PEOPLE_POST_SALARY_IN_ADVANCE_BAD_REQUEST_SalaryAdvanceTypeInvalid: 'Debe ser válido el Id del tipo de anticipo',
    SICHERN_PEOPLE_POST_SALARY_IN_ADVANCE_BAD_REQUEST_PlannedDateMustGreaterThanRequestDate: 'La fecha planificada debe ser mayor que la fecha solicitada',
    SICHERN_PEOPLE_POST_SALARY_IN_ADVANCE_BAD_REQUEST_SalaryAdvanceAmountInvalid: 'El monto del anticipo debe ser mayor a 0',
    SICHERN_PEOPLE_POST_SALARY_IN_ADVANCE_BAD_REQUEST_AmountOutOfRange: 'El monto solicitado está fuera del rango permitido',
    SICHERN_PEOPLE_POST_SALARY_IN_ADVANCE_BAD_REQUEST_EmployeeIdNotFound: 'Debe existir el Id del colaborador',
    SICHERN_PEOPLE_POST_SALARY_IN_ADVANCE_BAD_REQUEST_CurrencyIdNotFound: 'Debe existir el Id de la divisa',
    SICHERN_PEOPLE_POST_SALARY_IN_ADVANCE_BAD_REQUEST_AdvancesAllowedPerYearValidationMessage: 'Ha superado la cantidad anual de solicitudes de anticipo permitidas',
    SICHERN_PEOPLE_POST_SALARY_IN_ADVANCE_BAD_REQUEST_ExceedsConfiguredCapValidationMessage: 'El monto solicitado supera el límite permitido para este período',
    SICHERN_PEOPLE_NOT_EXISTS: 'Los datos del empleado no se encuentran en Sichern People',
    SICHERN_PEOPLE_INTEGRATION_NOT_ACTIVE: 'La integración con Sichern People no está activa',
    UNAUTHORIZED_USER_TO_CREATE_LICENCE: 'Usuario inautorizado para solicitar licencia',
    USER_NOT_FOUND_EXCEPTION: 'Usuario no encontrado',
    USER_LINK_EMAIL_WRONG_CODE: 'Codigo inválido, intente de nuevo.',
    SYSTEM_API_PARAMETER_IS_EMPTY: 'Falta enviar un parametro.',
    SYSTEM_API_PARAMETER_NOT_EXPECTED: 'Parametro no esperado.',
    USER_LINK_INVALID_CANDIDATE: 'User invalido para vincular',
    USER_LINK_TOKEN_EXPIRED: 'Token expirado',
    USER_LINK_WRONG_PASSWORD: 'Contraseña invalida',
    USER_LINK_PASSWORD_NOT_VERIFIED: 'Contraseña no verificada',
    USER_LINK_EMAIL_TOKEN_EXPIRED: 'Token para validar email expirado',
    USER_LINK_EMAIL_LAST_ATTEMPT:
      'Tienes un último intento! Si no recuerdas la clave puedes recuperar desde el login y luego retomar la vinculación. Luego del siguiente intento fallido no podrás vincular esta cuenta.',
    USER_LINK_LAST_ATTEMPT: 'Ultimo intento para ingresar el codigo',
    USER_LINK_LAST_ATTEMPT_FAILED:
      'Ultimo intento fallido para ingresar el codigo, no se va a vincular la ultima cuenta',
    USER_ENTITY_ID_NOT_FOUND: 'No se encontró el ID de la entidad del usuario',
    COULD_NOT_SEND_MAIL: 'No se pudo enviar el mail',
    LICENSE_TYPE_NOT_FOUND: 'Tipo de licencia no encontrada',
    LICENSE_MODULE_NOT_ACTIVE: 'Modulo de licencia no activo',
    SYSTEM_API_WRONG_DATA_TYPE: 'Tipo incorrecto de userId',
    LICENSE_MANAGER_REQUEST_ERROR: 'Hubo un error en la solicitud',
    LICENSE_MANAGER_APPROVER_IS_NOT_DEFINED: 'El aprobador no esta definido',
    LICENSE_MANAGER_APPROVER_NOT_FOUND: 'Aprobador no encontrado',
    LICENSE_MANAGER_FILE_NUMBER_NOT_MATCH_EXCEPTION:
      'El legajo del manager no coincide con el del aprobador',
    LICENSE_MANAGER_CREATE_ERROR: 'Error en la solicitud',
    HOLIDAY_PERIODS_NOT_FOUND: 'No se encontraron períodos de vacaciones',
    desconocido: 'Error desconocido',
    err500: 'No se ha podido generar el token',
    err400: 'No se pudo enviar la consulta',
    err404:
      'No se encontró o no está configurado correctamente el tipo de documento. (tipo: Genérico)',
    errorImageSize: 'Tamaño o formato inválido',
    errAccessRRHH: 'No tiene perfil de empleado o de aprobador',
    RequestStartDayNotAllowed: 'El día de inicio de la licencia no es válido',
    RequestEndDayNotAllowed: 'El día de fin de la licencia no es válido',
    EmployeeMustHaveAMinimumSeniorityForHolidayRequest: 'No posee antigüedad necesaria para solicitar vacaciones',
    BeginningOfAbsenceOnAHoliday: 'El día de inicio de la licencia no es válido',
    EndOfAbsenceOnAHoliday: 'El día de fin de la licencia no es válido',
    '012': 'usuario y/o contraseña incorrecta',
    '00001': 'Usuario y/o contraseña incorrectos.',
    '00002': 'Error interno',
    '00003': 'Hubo un problema, por favor vuelva a loguearse',
    '00009': 'No tienes permisos para ingresar a esta sección',
    '00015': 'Primer ingreso es requerido.',
    '00016': 'Primer ingreso ya realizado.',
    '00017': 'Algo salió mal.',
    '00018': 'Usuario bloqueado.',
    '00019':
      'La contraseña ingresada no cumple con las políticas de seguridad.',
    '00020': 'Token inválido.',
    '00021': 'Falló la generación del token.',
    '00022': 'Falló el registro del token.',
    '00023': 'Desregistro del token fallido',
    '00026': 'La contraseña ya ha sido usada',
    '00028': 'No posee este tipo de aplicación',
    '00029': 'El ID del documento no ha sido definido',
    '00030': 'La carpeta no existe',
    '00033': 'La contraseña nueva no puede ser igual a la anterior',
    '00034': 'Contraseña de verificación de identidad incorrecta',
    '00031': 'Error interno',
    '00036': 'El primer inicio de sesión no se pudo registrar',
    '00037': 'El ID de la aplicación no ha sido definido',
    '00038': 'El ID del documento no ha sido definido',
    '00039': 'Ingrese una contraseña para firmar',
    '00040': 'No posee permisos para realizar esta acción',
    '00041': 'No puede firmar recibos de una empresa anterior',
    '00042': 'La contraseña es incorrecta',
    '00043': 'El documento no existe',
    '00044': 'No tiene permisos para visualizar el documento',
    '00045':
      'Error al firmar el documento. El certificado para firmar carece de datos',
    '00046': 'Excedió la cantidad de cambios de contraseña',
    '00047': 'No se ha podido subir la imagen',
    '00048': 'Formato de imagen inválido',
    '00049': 'La imagen no puede ser menor o igual a 40px por 40px',
    '00050': 'Ingrese una imagen para recortar',
    '00051': 'Ingrese el ancho que tendrá la imagen',
    '00052': 'Ingrese el alto que tendrá la imagen',
    '00053': 'Ingrese la posición inicial del ángulo X',
    '00054': 'Ingrese la posición inicial del ángulo Y',
    '00055': 'Los datos no pudieron ser salvados',
    '00056': 'Verifica la imagen',
    '00057': 'No se puede visualizar este documento',
    '00069': 'La contraseña es obligatoria para actualizar la información',
    '00070': 'El email no ha sido definido',
    '00071': 'Contraseña incorrecta',
    '00072': 'El usuario no se ha identificado',
    '00073': 'No tienes permisos para modificar el usuario',
    '00074': 'Email incorrecto',
    '00076': 'La clave debe tener entre 8 y 32 caracteres',
    '00078': 'Error al obtener la configuración de la empresa',
    '00079': 'No tienes permiso para realizar esta acción',
    '00080': 'Error al obtener la configuración de la empresa',
    '00081': 'Error al obtener la configuración de la licencia',
    '00082': 'Error al obtener la aprobación de los usuarios',
    '00083': 'El usuario no puede solicitar una licencia',
    '00084': 'Error en la entrada de fechas',
    '00085': 'Error de criterios ingresados, verificar',
    '00086': 'Error de formato de fecha, se requiere dd/mm/aa',
    '00087': 'El id de la licencia no ha sido definido',
    '00088': 'Error al cancelar la licencia',
    '00089': 'Hubo un problema al crear la solicitud. Inténtalo de nuevo',
    '00094': 'Error en el certificado de firma',
    '00095': 'Debes introducir una acción.',
    '00096':
      "¡Acción no válida! Las acciones disponibles son: 'info', 'guardar', 'solicitar'",
    '00097': 'El usuario no ha sido definido.',
    '00098': 'El email no ha sido definido.',
    '00099':
      'No ha sido posible identificar el usuario, por favor contacte a RRHH de su empresa.',
    '00100': 'No pudimos crear el hash para el reseteo de contraseña.',
    '00101': 'Debes ingresar una nueva contraseña.',
    '00102': 'Debes repetir la nueva contraseña.',
    '00103': 'Las contraseñas no coinciden.',
    '00104': 'Por favor, haga el reseteo de contraseña nuevamente',
    '00105': 'Error de autentificación',
    '00106': 'Acción invalida',
    '00107': 'Se debe ingresar un usuario.',
    '00108': 'No se ha cargado un usuario o correo',
    '00109': 'Debe ingresar el código de activación',
    '00110': 'Código de activación incorrecto',
    '00111': 'La contraseña debe ser más compleja',
    '00112': 'La contraseña no debe contener información personal',
    '00113': 'La contraseña debe tener entre 8 y 32 caracteres',
    '00114':
      'Has superado el máximo de cambios de contraseña permitidos, contáctese con un administrador',
    '00115': 'No se puede actualizar la clave del registro.',
    '00116': 'No puede repetir la anterior',
    '00117': 'La contraseña no puede contener información personal del usuario',
    '00118':
      "Los campos 'Usuario', 'Nombre' y 'Apellido' son necesarios para validar la contraseña",
    '00119': 'La contraseña debe ser de mayor complejidad',
    '00120': 'La empresa no puede ser nula',
    '00121': 'La contraseña y el correo no pueden estar vacíos',
    '00122': 'El usuario no puede ser nulo',
    '00123': 'El nombre no puede ser nulo',
    '00124': "El apellido no puede ser nulo'",
    '00125': 'El DNI no puede ser nulo',
    '00126': 'El CUIL no puede ser nulo',
    '00127': 'El DNI ya existe',
    '00128': 'El CUIL ya existe',
    '00129': 'El mail ya existe',
    '00130': 'El nombre de usuario ya existe',
    '00131': 'El número de legajo ya existe',
    '00132':
      'La fecha de contratación no puede ser menor a la fecha de nacimiento',
    '00133':
      'Debe existir una diferencia mayor a 14 años entre la fecha de contratación y la fecha de nacimiento',
    '00134': 'No se pudieron guardar los datos',
    '00135': 'No se ha identificado al usuario',
    '00136': 'No se ha definido el algoritmo',
    '00137': 'No se ha definido el hash anterior',
    '00138': 'No se pudo eliminar el registro',
    '00139': 'Error al crear la firma',
    '00140': 'Error al auditar el cambio de contraseña',
    '00141': 'No se pueden repetir las últimas 3 contraseñas',
    '00142': 'Acceso inválido. Por favor vuelva a pedir el cambio de clave',
    '00143': 'El mail no es correcto',
    '00144': 'Hubo un problema, contáctese con soporte',
    '00145':
      'El primer inicio de sesión no se pudo registrar, el email pertenece a otro usuario de la empresa',
    '00608':
      'La configuración de firma se encuentra en una página que no existe. Para cambiarla por favor, contactarse con el administrador.',
    '02001': 'El tipo de licencia es incorrecto',
    '02006': 'Contraseña requerida.',
    '02059': 'Ingrese la Contraseña',
    '02060': 'No posee permiso para aprobar la licencia',
    '02061': 'La compañía no tiene una configuración de licencias',
    '02062': 'Ingresa el ID requerido',
    '02063': 'El pedido no fue encontrado',
    '02064': 'Hubo un error al pedir la licencia',
    '02065': 'No se ha podido realizar la aprobación de la licencia',
    '02066': 'Error al obtener el usuario aprobador.',
    '02067': 'El usuario que intenta aprobar no se encuentra.',
    '02068': 'Error al modificar el estatus de tu licencia',
    '02076': 'Contraseña incorrecta',
    '02079': 'No posee permisos para realizar esta acción',
    '02080': 'Error al obtener la configuración de la empresa',
    '02083': 'El usuario no puede solicitar una licencia',
    '02084': 'Error en la entrada de fechas.',
    '02089':
      'Hubo un problema al crear la solicitud, por favor intenta de nuevo',
    '02090': 'No se pudo notificar por correo',
    '02091':
      'Error al cambiar el aprobador o al guardar la aprobación de la licencia',
    '02092': 'Error al guardar los movimientos de la licencia',
    '02093': 'Error en la aprobación de la licencia',
    '02094': 'El usuario no existe',
    '02095': 'Error al generar los días',
    '02096':
      'No posee permisos para crear licencias en el usuario seleccionado',
    '02097': 'No posee permisos para realizar esta acción',
    '02098': 'No posee días suficientes',
    '02099': 'Error en la configuración de subtipos',
    '02100': 'Posee licencias pendientes de aprobación',
    '02101': 'La licencia no puede empezar un feriado',
    '02102': 'No se puede obtener la configuración del negocio.',
    '02103':
      'Hubo un inconveniente al crear el pedido, por favor, prueba de nuevo',
    '02104':
      "El número de legajo aprobador es exclusivo del módulo de licencias'",
    '02105': 'El nivel de aprobación es exclusivo del módulo de licencias',
    '02106': 'El código de convenio es exclusivo del módulo de licencias',
    '02107': "La antigüedad previa es exclusiva del módulo de licencias'",
    '02108': 'No tienes suficientes días para solicitar la licencia',
    '02109': 'La licencia debe ser pedida en el año en curso',
    '02110':
      'Hay una solicitud de licencia que se superpone con la que desea solicitar',
    '02111': 'No cumple con la política de fracción de licencia',
    '02112': 'No cumple con la política de fracción de licencia máxima',
    '02113':
      'No cumple con la política de solicitudes de licencia máxima mensual',
    '02114':
      'No cumple con la política de solicitudes de licencia máxima anual',
    '02115': 'No se cumple con la política de días de anticipación',
    '02116': 'No cumple con la política del día inicial',
    '02117': 'El número de días debe ser un número mayor que cero',
    '02118':
      'La fecha de finalización no puede ser inferior a la fecha de inicio',
    '02119': 'No hay días laborables en la solicitud realizada',
    '02120':
      'Ya posee licencias para el período seleccionado y excede la cantidad máxima permitida mensualmente',
    '02121':
      'Ya posee licencias para el período seleccionado y excede la cantidad máxima permitida anualmente',
    '02122': 'El módulo de licencias está inactivo',
    '02123': 'Error al calcular la solicitud',
    '02124': 'El número de usuarios excede el límite para generar el saldo',
    '02125': 'ID de tipo de licencia requerido',
    '02126': 'Tipo de licencias incorrecto',
    '02127': 'Tu perfil no tiene permisos para ejecutar esta acción',
    '02128': 'Política no válida',
    '02129': 'Tipo de licencia no válido',
    '02130': 'El ID de política e ID de licencia son inconsistentes',
    '02131':
      'El ID de usuario debe ser nulo cuando se utiliza el número de legajo',
    '02132':
      'El ID de usuario o número de legajo es obligatorio para solicitudes por terceros',
    '02138': 'Formato JSON no válido',
    '02139': 'Formato de fecha incorrecto. El formato debe ser DD/MM/AAAA.',
    '02140': 'Ya existen ajustes para esta configuración',
    '02141': 'Política no válida',
    '02142': 'Tipo de licencia no válido',
    '02143': 'La fracción minima debe ser mayor a cero',
    '02144': 'No cumple con la política de días multiplo de la fracción mínima',
    '02145': 'Subtipo de licencia no válido',
    '02146': 'No cumple con la política de día de retorno',
    '02148':
      'No puede seleccionar como día de inicio un feriado, seleccione el siguiente día hábil',
    '02150': 'Debe consumir al menos 7 días de saldo',
    '02151': 'Debe consumir al menos x días de saldo',
    '04002':
      'El empleado no pertenece a la empresa a la del usuario que subio el documento',
    '04003': 'Formato invalido',
    '04004': 'El PDF no puede exceder el total de páginas permitidas',
    '04005': 'Error al cargar el archivo',
    '04006': 'El campo nombre es requerido',
    '04007': 'El campo template es requerido',
    '04008': 'No eres administrador',
    '04009': 'El campo nombre es requerido',
    '04010': 'El campo Json es requerido',
    '04011': 'No se pudo obtener el usuario',
    '04012': 'No tienes permiso para realizar esta acción',
    '04013': 'El parámetro Id_type_document es requerido',
    '04014': 'El parámetro Template es requerido',
    '04015': 'El parámetro Files es requerido',
    '04016': 'El usuario no posee el action profile requerido',
    '04018': 'La cantidad de archivos subidos es incorrecta',
    '04019': 'El campo de valor es requerido',
    '04020': 'El Id_type_documen no pertenece a la compañia',
    '04021': 'Formato del Json invalido',
    '04022': 'Se debe agregar parametros junto al Json',
    '04023': 'Los parámetros adentro del Json son incorrectos',
    '04024':
      'El empleado no pertenece al sector del usuario que subio el documento',
    '04025':
      'El empleado no pertenece a la locacion del usuario que subio el documento',
    '04026': 'El documento debe estar en estado inicial',
    '04027': 'El status fue cambiado con éxito',
    '04028': 'Error al actualizar la base de datos',
    '04029': 'El status fue cambiado con éxito',
    '04030': 'El parámetro País no es correcto',
    '04031': 'El parámetro compañia no es correcto',
    '04032': 'El ID de la empresa debe ser numérico',
    '04033': 'El ID del país debe ser numérico',
    '04034': 'El ID es requerido',
    '04035': 'El nombre es requerido',
    '04036': 'El formato del archivo es incorrecto',
    '04037': 'El ID es incorrecto',
    '04038': 'El ID no pertenece a la carga del usuario',
    '04039': 'La carga del archivo falló',
    '04040': 'Nombre incorrecto.',
    '04041': 'Error al actualizar el template',
    '04042': 'Ya se completo la carga maxima de archivos',
    '04043': 'No puedes ver documentos de otras compañías',
    '04044': 'El campo hash es requerido',
    '04045': 'Los hash no coinciden',
    '04046': 'No se pudo crear el directio correctamente',
    '04047': 'El documento no existe',
    '04049': 'El archivo excede el tamaño máximo',
    '04051': 'No se puede leer el archivo PDF',
    '04744': 'Usuario inhabilitado, contacte con el administrador',
    '00146': 'Su contraseña ha expirado, debe actualizarla para poder firmar',
    '00147': 'Su acceso a firmar ha sido bloqueado por multiples intentos fallidos'
  },
  settingsComponent: {
    header: {
      upload: 'Cargar imagen',
      change: 'Editar imagen',
      cropImage: 'Cortar imagen',
      exitEditMode: 'Guardar',
      cancelEditMode: 'Cancelar',
      saveChanges: 'Actualizar foto',
      cropSuccess: 'Imagen de perfil cambiada con éxito',
      title: 'Configuración',
      titleProfilePicture: 'Cargar foto de perfil'
    },
    list: {
      changePassword: {
        title: 'Editar clave',
        dialogTitle: 'Cambia tu clave de acceso',
        labelOldPass: 'Ingrese clave actual',
        labelPass: 'Ingrese nueva clave',
        labelRePass: 'Repita nueva clave',
        samePassValidation: 'Las contraseñas no coinciden',
        success: 'Contraseña modificada con éxito'
      },
      changeEmail: {
        title: 'Editar email',
        dialogTitle: 'Cambia tu email personal',
        currentEmail: 'Tu correo electrónico actual asociado es',
        labelEmail: 'Email nuevo',
        labelEmail2: 'Correo electrónico nuevo',
        labelPassword: 'Contraseña',
        labelPassword2: 'Clave actual',
        labelEmailAndPassword:
          'Introduce un correo electronico nuevo y tu clave actual',
        success: 'Email modificado con éxito'
      },
      switchCompany: {
        title: 'Cambiar empresa',
        companyLabel: 'Empresa',
        success: 'Se ha cambiado de empresa',
        stateUser: 'Estado',
        companyState1: 'Activo',
        companyState2: 'Onboarding',
        actionChangeCompany: 'Cambiar',
        stateCurrentCompany: 'Actual',
        myCompanies: 'Mis empresas',
        blockedCompany: 'Usuario inhabilitado, contacte con el administrador.',
        onboardingAlert: {
          cancelBtn: 'Cancelar',
          confirmBtn: 'Cambiar',
          header: 'Cambio de empresa',
          text:
            'En la empresa {relatedCompanyName} te encuentras en proceso de onboarding. Serás redirigido a la pantalla de inicio de sesión',
          title: '¿Estás seguro que quieres cambiar de empresa?'
        }
      },
      mfaSettings: {
        dialogTitle: 'Autenticación por correo electrónico',
        info:
          'Para tu seguridad puedes añadir un factor de autenticación para verificar tu acceso a través de la cuenta de email asociada.',
        yes: 'Si',
        no: 'No',
        warnMessageMfaYes:
          'Al guardar los cambios se cerrará la sesión y deberás volver a loguearte para establecer la primera configuración.',
        warnMessageMfaNo:
          'Desactivar la Autenticación por correo electrónico aumenta el riesgo de accesos no autorizados a su cuenta. Si deshabilita, se recomienda que vuelva a reactivarlo lo antes posible.',
        notEditable:
          'Su empresa a marcado como obligatorio el uso del doble factor de autenticación, no es posible editar esta sección',
        passRequiredInfo:
          'Contraseña requerida para confirmar el cambio de configuración',
        passRequired: 'Por favor ingrese su contraseña',
        invalidPassword: 'Contraseña incorrecta',
        errorSavingSettings: 'Error al guardar la configuración',
        passwordLabel: 'Contraseña'
      },
      privacyNotice: {
        title: 'Aviso de Privacidad'
      },
      FileUploadComponent: {
        header: {
          title: 'Carga de documentos'
        },
        title_img: 'Seleccione el documento a cargar',
        subtitle_img: 'Una vez seleccionado se visualizará aquí',
        stepper: {
          first: 'Elegí el tipo de documento',
          second: 'Completá los datos necesarios',
          third: 'Enviaselo a RRHH'
        },
        formComponent: {
          loadSuccess1: 'El documento se envió correctamente.',
          loadSuccess: 'El documento se envió correctamente.',
          uploadSuccess: 'Carga de documento completada',
          errorLoadSomeDoc: 'Hubo un error en la carga del documento.',
          loadAllPages:
            'Por favor suba una imagen en todos las hojas agregadas.',
          errorOnId: 'Hubo un error al traer el id de carga',
          checkSizeOnPdf: 'Por favor, suba un pdf de hasta de 5 MB',
          selectPdf: 'Por favor Seleccione un pdf',
          selectFile: 'Seleccione un archivo',
          imageSucces: 'La hoja se subió correctamente',
          selectJpgPng:
            'Por favor seleccione una imagen jpg o png de hasta de 5 MB',
          addNewField: 'Añadir hoja',
          replaceField: 'Reemplazar hoja',
          eliminateField: 'Eliminar hoja',
          addNewFieldShort: 'Añadir',
          replaceFieldShort: 'Reemplazar',
          eliminateFieldShort: 'Eliminar',
          preview: 'Previsualización',
          loadImage: 'Cargar imagen',
          loadFIle: 'Cargar documento',
          invalidFormatFile: 'Archivo de formato inválido'
        },
        swal: {
          accept: 'Aceptar',
          cancel: 'Cancelar',
          understoodMSG: 'Entendido',
          imageSaved: 'Imagen Guardada',
          titleUploadViewer:
            'Ha llegado a la cantidad máxima de archivos permitidos',
          dnimessage: 'Imagen Guardada ({uploadLength} de {uploadLength})',
          dniUploading: 'Imagen Guardada (1 de {uploadLength})',
          fileUploadingDNI:
            'A continuación carga el {dniLabelIndex} del documento'
        },
        cameraComponent: {
          buttons: {
            manualCrop: 'Recorte manual',
            autoDetection: 'Detección automática',
            rotate: 'Rotar Foto'
          },
          permissionDenied: 'No se otorgaron permisos para acceder a la cámara'
        },
        documentSelectLabel: 'Tipo de documento',
        sendDocumentsToS3: 'Enviar',
        total: 'Total',
        emptyState: 'No hay documentos para cargar',
        previewBtn: 'Previsualizar',
        addSheet: '+ Añadir hoja',
        sendRRHH: 'Enviar a RRHH',
        enableSendRRHH:
          'Para habilitar el botón con la opción Enviar a RRHH, primero debes adjuntar la imagen/pdf solicitado, o eliminar las hojas adicionales que no necesites completar.',
        sendFileRRHH:
          'Ahora ya puede enviar el documento a RRHH para su revision',
        continueConfig: '¿Cómo desea continuar?'
      },
      dates: {
        searchByPeriod: 'Búsqueda por período',
        datePicker: 'Elige una fecha',
        dateSince: 'Fecha desde',
        dateLast: 'Fecha hasta',
        cancelButton: 'Cancelar',
        submitButton: 'Ok'
      },
      dateSince: 'Fecha desde:',
      dateLast: 'hasta:',
      saveFilters: 'Aplicar',
      CleanFilters: 'Limpiar',
      okMsg: 'Aceptar',
      buttonCancel: 'Cancelar',
      save: 'Guardar',
      saveSuccess: 'Guardado correctamente',
      businessChange: 'Cambiando empresa',
      authentic: 'Autenticando...'
    },
    changeTo: 'Cambiar a',
    changeBussiness: 'Cambiar de empresa',
    rolTitle: 'Rol',
    changeVisualization: 'Cambiar perfil de visualización',
    managerTitle: 'Manager',
    colaboradorTitle: 'Colaborador',
    changeAnotherBusiness: 'Cambiar a otra empresa',
    myAccount: 'Mi cuenta',
    manager: 'Manager',
    changePesonalData: 'Cambiar datos personales',
    editPassword: 'Editar contraseña',
    changeAccessKey: 'Cambiar clave de acceso',
    editEmail: 'Editar email',
    changePersonalEmail: 'Cambiar email personal',
    securityAdds: 'Ajustes de seguridad',
    authPreferences: 'Preferencias de autenticación',
    privacyPolicy: 'Política de privacidad',
    getOut: 'Salir',
    documents: 'Documentos',
    collab: 'Colaboradores',
    licencesCollab: 'Licencias',
    folders: 'Carpeta',
    linkEmailAccount:
      '¿Estas seguro que quieres vincular tus cuentas con el siguiente [ Email ]?',
    confirmAccion: 'Esta acción no se puede deshacer.'
  },
  documentComponent: {
    details: {
      documentCount: '{length} hoja',
      documentCountPlural: '{length} hojas',
      documentTitle: 'Documento',
      confort: 'Conforme',
      notConfort: 'No conforme',
      notRequiredSign: 'No requiere firma'
    },
    unSignDocuments: {
      unsignedDocuments: 'Documentos sin firmar',
      noDocuments: '¡No hay documentos para firmar!',
      noFirm: 'No firmado',
      bloqued: 'Bloqueado',
      consultRRHH: 'Consultado'
    },
    SignedDocuments: {
      myDocuments: 'Mis Documentos',
      dissatisfiedSignature: 'Disconforme',
      noSignedDocuments: 'Usted no tiene documentos firmados',
      sendDocument: 'Firmar',
      disagreementSignature: 'Firma en disconformidad'
    },
    warnings: {
      titleDocumentBloqued: '¡Atención!',
      subtitleDocumentBloqued:
        'Existen documentos anteriores sin firmar. Deberá firmarlo para poder visualizar este documento.',
      subtitle2DocumentBloqued:
        'Deberá firmarlo para poder visualizar este documento.'
    },
    filters: {
      combobox: {
        documentTypes: 'Tipo de documento',
        noDocumentTypes: 'No posee filtros para esta sección',
        comboboxLabel: 'Agrega algunos tags',
        comboboxNoResults: 'No se encontraron resultados'
      },
      dates: {
        searchByPeriod: 'Búsqueda por período',
        datePicker: 'Elige una fecha',
        dateSince: 'Fecha desde',
        dateLast: 'Fecha hasta',
        cancelButton: 'Cancelar',
        submitButton: 'Ok'
      },
      dateSince: 'Fecha desde:',
      dateLast: 'hasta:',
      saveFilters: 'Aplicar filtros',
      CleanFilters: 'Limpiar filtros'
    },
    tooltip: {
      main: {
        top: 'Para poder firmar este documento',
        single: 'Tienes que firmar 1 documento prioritario',
        plural: 'Tienes que firmar {count} documentos prioritarios',
        bottom: 'Haz clic en el documento para poder revisarlos y firmarlos'
      }
    },
    opcions: 'más opciones',
    noDocumentsAble: 'No tienes documentos disponibles',
    pending: 'Pendientes',
    signed: 'Firmados',
    activeEmployees: 'Sólo documentos de empleados activos',
    toFind: 'Busqueda por {dni}',
    maxSearch: 'La búsqueda permite un máximo de 100 {dni} separados por comas',
    timeDocument: 'Tipo de documento / Periodo',
    sectorLocation: 'Sector / Locación'
  },
  documentVisualizerComponent: {
    loading: {
      loadingMessage: 'Estamos procesando su petición por favor espere...'
    },
    signButtons: {
      signDissatisfied: 'Firmar no conforme',
      rrhhConsult: 'Consultar a RRHH',
      rrhhConsultReady: 'Ver Consulta',
      signDocument: 'Firmar Documento',
      sendDocument: 'Enviar',
      signWithOptions: 'Más opciones'
    },
    signDialog: {
      signNotConfort: 'Firmar no conforme',
      inputPassword: 'Ingresa la contraseña',
      signConfort: 'Firmar Documento',
      cancelButton: 'Cancelar',
      saveButton: 'Firmar Documento'
    },
    signNotConfort: {
      select: 'Otros Motivos',
      reasons: {
        one: 'Liquidación de Hs Extras',
        two: 'Liquidación otros Conceptos',
        three: 'Otros Motivos',
        four: 'Diferencia en liquidación de haberes',
        five: 'Diferencia en liquidación de retenciones',
        six: 'Diferencia en liquidación de adicionales'
      }
    },
    consultRRHHModal: {
      consultRRHHTitle: 'Hacer una consulta a RRHH',
      consultReadyRRHHTitle: 'Ver consulta',
      submitConsultRRHH: 'Escriba aquí su consulta a RRHH',
      cancelButton: 'Cancelar',
      consult: 'Consultar'
    },
    errors: {
      errorDate: 'Hubo un error al obtener la fecha de firmado'
    },
    firmSuccess: 'Se ha firmado el documento correctamente',
    incorrectPassword: 'Contraseña incorrecta',
    consultSuccessRRHH: 'La consulta se ha enviado correctamente',
    downloadPDF: 'Descargar',
    sendEform: 'Enviar Documento',
    printDocument: 'Imprimir',
    forgetPassword: '¿Olvidó su contraseña?',
    sending: 'Enviando...'
  },
  licenseComponent: {
    licenseBox: {
      days: 'Días',
      day: 'Día',
      // available: 'Disponibles del tipo licencia',
      // registered: 'Registrados del tipo licencia',
      // available1: 'Disponible del tipo licencia',
      // registered1: 'Registrado del tipo licencia',
      available: 'Disponibles',
      registered: 'Registrados',
      available1: 'Disponible',
      registered1: 'Registrado',
      discountPlural: 'Se descontarán {saldo} días de {tipo} de su saldo',
      registerPlural: 'Se registrarán {saldo} días de {tipo} a su saldo',
      discountSingular: 'Se descontará {saldo} día de {tipo} de su saldo',
      registerSingular: 'Se registrará {saldo} día de {tipo} a su saldo',
      discountHalf: 'Se descontará medio día de {tipo} de su saldo',
      registerHalf: 'Se registrará medio día de {tipo} a su saldo',
      registerAnticipatePayment: 'Solicitar anticipo de pago de vacaciones',
      buttonSolicitudeLicense: 'Solicitar',
      buttonSolicitudeLicenseDisabled: 'No posee días',
      HistoryLicenses: 'Historial de solicitudes',
      licenseTypeLabel: 'Tipo',
      initError: 'Existe un problema de configuración. Informar a RRHH.',
      datesTitle: 'Seleccione fecha de inicio y de reincorporación',
      datesRangeTitle: 'Seleccione el rango de fechas',
      datesRangeDescription:
        'Desde el día que inicia tu licencia hasta el día que regresas a la oficina',
      tooltipInfo:
        'El día de regreso o de retorno no se tiene en cuenta en la solicitud y no se descontará de tu saldo',
      dateFromTitle: '¿Cuándo es la fecha de inicio?',
      dateToTitle: '¿Cuándo te reincorporas a la empresa?',
      dateFrom: 'Fecha de inicio',
      dateTo: 'Fecha de reincorporación',
      // start: 'Inicio',
      start: 'Desde',
      // return: 'Reincorporación',
      return: 'Hasta',
      halfDay: 'Solo medio día',
      approverTitle: '¿Quién aprueba ésta solicitud?',
      approver: 'Aprobador',
      optionalTitle: 'Opciones adicionales',
      liqPeriod: 'Periodo de liquidación',
      commentTitle: '¿Desea agregar algún comentario?',
      commentLabel: 'Observaciones',
      francos: 'Francos',
      goOut: 'Salir',
      back: 'Volver',
      next: 'Siguiente',
      cancel: 'Cancelar solicitud',
      balances: 'Saldos',
      requestLicense: 'Solicitar',
      resume: 'Resumen',
      pendingLicenses:
        'Existen {pendingLicenses} solicitudes pendientes de su aprobación',
      selectLicenseType:
        'Seleccione el tipo de vacaciones o licencias que desea solicitar',
      balanceDetails: 'Detalle de saldo',
      timeRangeDescription: 'Seleccione el rango de horas',
      discountHours: 'Se descontará {hoursRanges} horas de {tipo} de su saldo',
      discountSingularHour:
        'Se descontará {hoursRange} hora de {tipo} de su saldo',
      communicateWithSupport:
        'Error en la configuración de la integración de certificados. Por favor contacte con soporte',
      cciAccountInvalid: 'El numero de cuenta y cci no coinciden',
      sichernPeopleInfo: 'Detalle de Sichern People',
      inicioLabel: 'Inicio',
      limiteLabel: 'Límite',
      disponiblesLabel: 'Disponibles',
      vencenLabel: 'Por vencer',
      diasAAcreditarseLabel: 'Días a acreditarse',
      usadosLabel: 'Usados',
      periodoLabel: 'Período',
      transferidosLabel: 'Transferidos',
      legalesLabel: 'Legales',
      acordadosLabel: 'Acordados',
      conformacionSaldo: 'Conformación de saldo',
      gozadosLabel: 'Gozados',
      toCreditLabel: 'A acreditarse',
      tooltipToCredit: 'Además de tus días disponibles, también podés planificar y solicitar por adelantado tus vacaciones del próximo período.',
      legalesTooltip: 'Días de licencia establecidos por ley.',
      transferidosTooltip: 'Días no utilizados del período anterior que se trasladan al actual según política de la empresa.',
      acordadosTooltip: 'Días adicionales acordados con la empresa.',
      gozadosTooltip: 'Días de licencia solicitados en el período (aprobados o pendientes).',
      disponiblesTooltip: 'Días de licencia no gozados y aún están vigentes.',
      vencenTooltip: 'Días de licencia disponibles que deben gozarse antes de la fecha límite establecida.',
      diasAAcreditarseTooltip: 'Días de licencia habilitados para planificar y gozar el próximo período.'
    }
  },
  LicensesHistoryComponent: {
    tabs: {
      licenses: {
        tabName: 'Solicitudes',
        tabName_mine: 'Mis solicitudes',
        myLicenses: 'Mis vacaciones y licencias',
        title: 'Historial de vacaciones y licencias',
        subtitleState: 'Estado:',
        subtitleStateWaiting: 'En aprobación',
        subtitleSolicitudeDate: 'Fecha de solicitud:',
        emptyHistory: 'No existen licencias o vacaciones para mostrar',
        emptyHistorySubtitle: 'Tu listado está vacío.',
        emptyHistorySubtitle2: 'Haz una solicitud y podrás visualizarla aquí',
        noMoreResults: 'No hay más resultados',
        start: 'Inicio',
        return: 'Regreso'
      },
      otherRequests: {
        tabName: 'Otras ausencias',
        title: 'Otras ausencias solicitadas por RRHH'
      },
      licensesForApproval: {
        loadLicences: 'Cargar ausencias',
        licensesPending: 'Pendientes de aprobación',
        licenseType: 'Tipo:',
        historyLicenses: 'Mis vacaciones y licencias',
        startDate: ' Fecha de inicio:',
        reincorporationDate: 'Fecha de reincorporación:',
        daysQuantity: 'Cantidad de días:',
        noLicensesForApprovalTitle: 'No existen pendientes de aprobación',
        noLicensesForApprovalSubtitle: 'Aquí aparecerán las',
        noLicensesForApprovalSubtitle2: 'Solicitudes que necesitan aprobación',
        day: 'día',
        days: 'días',
        from: 'Desde',
        to: 'a',
        return: 'regreso'
      }
    },
    statusPending: 'Pendiente',
    statusExpired: 'Saldo vencido',
    downloadDocument: 'Descargar documento'
  },
  LincensesHistorySummaryComponent: {
    header: {
      title: 'Detalle de solicitud'
    },
    sumary: {
      quitLicenseOk: 'La solicitud se ha cancelado con éxito'
    },
    labels: {
      licenseType: 'Tipo',
      licenseType2: 'Tipo de licencia',
      solicitudeState: 'Estado',
      status: 'Estado',
      solicitudeDate: 'Fecha de solicitud',
      request: 'Solicitud',
      approver: 'Aprobador',
      startDate: 'Desde',
      reincorporationDate: 'Hasta',
      // startDate: 'Inicio',
      // reincorporationDate: 'Reincorporación',
      return: 'Regreso',
      requestedDays: 'Días solicitados',
      days: 'Días',
      accumulatedDays: 'Días acumulados',
      balance: 'Saldo disponible',
      comment: 'Observaciones',
      firstApproverState: 'En manos de aprobador nivel 1',
      secondApproverState: 'En manos de aprobador nivel 2',
      attachmentDocument: 'Documento adjunto',
      addCalendar: 'Puedes agregar la licencia a tu calendario de gmail',
      name: 'Nombre',
      licenseDaysByPeriod: 'Días de vacaciones solicitadas por período',
      action: 'Acción'
    },
    modals: {
      title: '¿Está seguro que desea cancelar la solicitud?',
      cancelSolicitudeSucces: 'La solicitud fue cancelada con éxito'
    },
    cancelButton: 'Cancelar Solicitud',
    addCalendar: 'Agregar al calendario'
  },
  LincensesApprovalPendingComponent: {
    header: {
      title: 'Detalle de solicitud'
    },
    labels: {
      nameLastname: 'Solicitante',
      nameLastname2: 'Nombre y Apellido',
      licenseType: 'Tipo',
      day: 'Día',
      days: 'Días',
      stateSolicitude: 'Estado de la solicitud',
      state: 'Estado',
      solicitudeDate: 'Fecha de solicitud',
      request: 'Solicitud',
      startDate: 'Inicio',
      reincorporationDate: 'Reincorporación',
      startReturn: 'Inicio / Regreso',
      requestedDays: 'Días Solicitados',
      salaryAvailable: 'Saldo disponible',
      salaryAvailablePostApprove: 'Saldo disponible luego de aprobar',
      salaryRegistered: 'Saldo registrado',
      daysInThisYear: 'Días acumulados en el año actual',
      observations: 'Observaciones',
      fileNumber: 'Legajo',
      employeeInfoTitle: 'Información de empleado',
      dni: 'Número de documento',
      email: 'Correo electrónico',
      historyTitle: 'Historial de vacaciones y licencias',
      actionDoneBy: 'Acción realizada por',
      action: 'Acción'
    },
    modal: {
      massiveApprove: 'Aprobar selección',
      massiveReject: 'Rechazar selección',
      approveTitle: 'Aprobar solicitud',
      rejectTitle: 'Rechazar solicitud',
      approverPlaceholder: 'Seleccionar siguiente aprobador',
      defaultApproverPlaceholder: 'Definirme como aprobador por defecto',
      observationsPlaceholder: 'Observaciones',
      placeholder: 'Introduzca su contraseña',
      label: 'contraseña',
      approveLicenseOk: 'La solicitud se aprobó correctamente.',
      desapproveLicenseOk: 'La solicitud se rechazó correctamente',
      cancelButton: 'Cancelar',
      okButton: 'Aceptar',
      cantApproveMassive: 'Esta selección no permite aprobación masiva.',
      massiveApproveError: 'Algunas solicitudes no se pudieron aprobar.',
      massiveRejectError: 'Algunas solicitudes no se pudieron rechazar.',
      massiveRejectExpired:
        'Alguna de las licencias que está por rechazar tiene saldo vencido',
      singleRejectExpired:
        '{days} días solicitados han superado la fecha de vencimiento, si la rechaza, el saldo se vencerá'
    },
    cancelButton: 'Rechazar',
    approveButton: 'Aprobar'
  },
  LicensesSolicitudeComponent: {
    header: {
      title: 'Solicitar'
    },
    modals: {
      solicitudeOk: 'Se ha creado la solicitud con éxito',
      cancelRequest: '¿Está seguro que desea cancelar esta solicitud?',
      yes: 'Si',
      no: 'No',
      continue: 'Continuar'
    },
    fileUploadMessage: 'Adjunte la documentación correspondiente'
  },
  LicensesManager: {
    goBack: 'Volver a la gestión',
    orderBy: 'Ordenar por',
    redirect: {
      title:
        '¡Lo sentimos! Ésta página no está disponible en este dispositivo.',
      subtitle: 'Para acceder debes ingresar desde tu computadora',
      backToHome: 'Volver al home'
    },
    rotateScreen: {
      title: 'Girar dispositivo',
      subtitle:
        'Para poder visualizar correctamente esta pantalla es necesario que gires tu dispositivo',
      hint:
        'Recuerda activar el giro de pantalla desde la configuración de tu celular'
    },
    landing: {
      title: 'Gestión de licencias',
      title_request: 'Solicitar',
      subtitle_request: 'Solicite sus licencias y vacaciones',
      info_request1: '{availableDays} Días',
      info_request2: 'Disponibles de {licenseType}',
      info_request_registered: 'Registrados de {licenseType}',
      title_pending: 'Pendientes de aprobación',
      subtitle_pending:
        'Apruebe o rechace las solicitudes pendientes de sus empleados',
      info_pending1: '{pendingLicenses} licencias',
      info_pending2: 'Pendientes de aprobación',
      title_licenses_search: 'Consulta de solicitudes',
      subtitle_licenses_search:
        'Consulte y exporte el detalle de una o varias solicitudes',
      title_balances: 'Reporte de saldo',
      subtitle_balances:
        'Consulte y exporte el saldo detallado de los empleados',
      title_nonworkingdays: 'Feriados',
      subtitle_nonworkingdays: 'Consulte los feriados por país y por empresa'
    },
    search: {
      title: 'Consulta de solicitudes',
      empty: 'Los resultados de tu búsqueda se mostrarán aquí',
      userHint: 'Se puede buscar por nombre, apellido o CUIL',
      user: 'Usuario',
      status: 'Estado',
      type: 'Tipo',
      userStatus: 'Estado usuario',
      fromPeriod: 'Periodo desde',
      toPeriod: 'Periodo hasta',
      liqPeriod: 'Periodo de liquidación',
      search: 'Buscar',
      export: 'Exportar',
      exportLoading: 'Exportando...',
      fileNumber: 'Número de legajo',
      requestDate: 'Fecha de solicitud',
      sector: 'Sector',
      location: 'Locación',
      balanceDetail: 'Conformación de saldo',
      nameLastname: 'Nombre y Apellido',
      lastnameName: 'Apellido y Nombre',
      searchName: 'Apellido y Nombre / {dni}',
      name: 'Nombre',
      surname: 'Apellido',
      start: 'Inicio',
      return: 'Reincorporación',
      days: 'Días',
      statusList: {
        pendingSupervisor: 'En aprobación Supervisor',
        pendingHr: 'En aprobación RRHH',
        approved: 'Aprobada',
        cancelled: 'Cancelada',
        rejected: 'Rechazada',
        outdated: 'Vencida',
        assignment: 'Asignación'
      },
      userStatusActive: 'Activo',
      userStatusUnactive: 'Inactivo',
      all: 'Todos',
      fileUploaded: 'Documento cargado',
      fileNotUploaded: 'Documento no cargado',
      viewUploadedFile: 'Visualizar documento'
    },
    balances: {
      title: 'Reporte de saldo',
      period: 'Periodo',
      woBalance: 'Sin saldo'
    },
    holidays: {
      title: 'Feriados',
      subtitle: 'Días festivos del año {year}',
      day: 'Día',
      name: 'Nombre',
      type: 'Tipo',
      politicHoliday: 'Feriado por política',
      companyHoliday: 'Feriado por empresa',
      countryHoliday: 'Feriado por país',
      deleteHolidayQuestion:
        '¿Está seguro que quiere eliminar el feriado {holiday}?',
      delete: 'Eliminar',
      deleteSuccess: 'El feriado se eliminó exitosamente'
    },
    managerLicense: {
      title_calendar: 'Calendario',
      subtitle_calendar:
        'Visualice el estado de las ausencias de tus colaboradores'
    }
  },
  UploadLanding: {
    pageTitle: 'Enviar documento',
    uploadFile: {
      title: 'Carga de archivos',
      description:
        'Enviarle documentación a recursos humanos. Sacandole una foto o seleccionando un archivo pdf.',
      button: 'Ir a carga de archivos'
    },
    pickup: {
      title: 'Completar formularios',
      titleSing: 'Completar formulario',
      description:
        'El sector de recursos humanos te disponibiliza formularios para que los completes cuando sea necesario.',
      button: 'Ir a completar formularios'
    }
  },
  FileUploadComponent: {
    header: {
      title: 'Carga de documentos'
    },
    title_img: 'Seleccione el documento a cargar',
    subtitle_img: 'Una vez seleccionado se visualizará aquí',
    stepper: {
      first: 'Elegí el tipo de documento',
      second: 'Completá los datos necesarios',
      third: 'Enviaselo a RRHH'
    },
    formComponent: {
      loadSuccess1: 'El documento se envió correctamente.',
      loadSuccess: 'El documento se envió correctamente.',
      uploadSuccess: 'Carga de documento completada',
      errorLoadSomeDoc: 'Hubo un error en la carga del documento.',
      loadAllPages: 'Por favor suba una imagen en todos las hojas agregadas.',
      errorOnId: 'Hubo un error al traer el id de carga',
      checkSizeOnPdf: 'Por favor, suba un pdf de hasta de 5 MB',
      selectPdf: 'Por favor Seleccione un pdf',
      selectFile: 'Seleccione un archivo',
      selectFilePdf: 'Seleccionar archivo PDF',
      selectFileImage: 'Seleccionar imagen',
      imageSucces: 'La hoja se subió correctamente',
      selectJpgPng:
        'Por favor seleccione una imagen jpg o png de hasta de 5 MB',
      addNewField: 'Añadir hoja',
      replaceField: 'Reemplazar hoja',
      eliminateField: 'Eliminar hoja',
      addNewFieldShort: 'Añadir',
      replaceFieldShort: 'Reemplazar',
      eliminateFieldShort: 'Eliminar',
      preview: 'Previsualización',
      takeAPhoto: 'Tomar foto',
      selectDocument: 'Seleccionar documento',
      searchFile: 'Buscar archivo',
      allowedFiles: 'Archivos permitidos',
      maxFileSize: 'Tamaño máximo'
    },
    swal: {
      accept: 'Aceptar',
      cancel: 'Cancelar'
    },
    cameraComponent: {
      buttons: {
        manualCrop: 'Recorte manual',
        autoDetection: 'Detección automática',
        rotate: 'Rotar Foto'
      },
      permissionDenied: 'No se otorgaron permisos para acceder a la cámara'
    },
    documentSelectLabel: 'Tipo de documento',
    sendDocumentsToS3: 'Enviar',
    total: 'Total',
    emptyState: 'No hay documentos para cargar'
  },
  Pickup: {
    text_fail_password: 'Contraseña incorrecta',
    cancel: 'Cancelar',
    text_send: 'Enviar',
    title_eforms_sign: 'Ingreso de Clave',
    accept: 'Aceptar'
  },
  first_login_terms_conditions: 'términos y condiciones',
  passwordPolicies: {
    rangeChar:
      'La clave debe tener {min} caracteres como mínimo y {max} como máximo.',
    minMayus: ' La clave debe tener al menos {min} carácter en mayúscula.',
    minLongLetter: ' La clave debe tener al menos {min} letra.',
    // mayusRange: "La clave debe tener entre {minMayus} y {maxMayus} mayúsculas.",
    // numberRange: "La clave debe tener entre {minNumber} y {maxNumber} números.",
    // specialCharRange: "La clave debe tener entre {minSpecial} y {maxSpecial} caracteres especiales.",
    // specialCharAllowed: "Caracteres especiales permitidos: {specialChar}.",
    anotherRules:
      'La contraseña no puede contener información personal del usuario (Usuario, Nombre, Apellido)'
  },
  greeting: {
    morning: 'Buenos días',
    afternoon: 'Buenas tardes',
    evening: 'Buenas noches'
  },
  eforms: {
    titles: {
      warning: '¡Atención!'
    },
    errors: {
      e12029:
        'Alguna de las imágenes adjuntas no es válida. Por favor revíselas y vuelva a intentarlo',
      e12030:
        'Alguna de las imágenes no pudo ser almacenada. Por favor intente más tarde'
    },
    digitalForms: 'Formularios digitales'
  },
  mfa: {
    code_authentication: {
      title: 'Código de verificación',
      sub_title_wrong_code:
        'El código de verificación no es válido. Por favor, inténtelo de nuevo',
      sub_title_valid_code:
        'Ingresá el código de verificación de 6 números que te enviamos a tu email',
      sub_title_expired_code: 'Código expirado',
      sub_title_resend_code: 'Reenviar Código',
      sub_title_time_expired_code: 'El código expira en',
      go_back_btn: 'Volver',
      send_btn: 'Enviar',
      sending_btn: 'Enviando',
      maxFailsExceededDescription:
        'Realizó demasiados intentos fallidos inicie sesión nuevamente',
      go_to_login_btn: 'Ir al login',
      SYSTEM_MFA_AUTH_MAX_RESEND_EXCEEDED:
        'Realizó demasiados peticiones al servidor.',
      COULD_NOT_SEND_MAIL: 'No se pudó enviar el email'
    },
    email_verification: {
      title: 'Ingrese un email',
      description:
        'Para tu seguridad necesitamos verificar tu cuenta de email asociada, por favor ingresa un email válido. Te enviaremos un código que deberás ingresar en el siguiente paso.',
      input_label: 'Email',
      go_back: 'Volver',
      send: 'Enviar'
    },
    userBlock: {
      title: 'Código de verificación',
      description:
        'Realizo demasiados pedidos de verificación por motivos de seguridad se inhabilitó su cuenta por 1 hora',
      go_back_btn: 'Volver'
    }
  },
  notifications: {
    new_update: 'Tenemos una nueva actualización',
    understood: 'Entendido'
  },
  selfService: {
    goBack: 'Volver',
    title: 'Actualización de datos',
    sections: {
      contact: 'Datos de contacto',
      bank: 'Datos bancarios',
      identifies: 'Cómo me identifico',
      address: 'Cambio de domicilio'
    },
    actions: {
      save: 'Actualizar datos',
      sign: 'Firmar'
    },
    fields: {
      name: '¿Cómo quieres que te llamemos?',
      genre: 'Género',
      photo: {
        title: '¿Quieres actualizar tu foto en la plataforma?',
        description:
          'Puedes enviar una foto para actualizar tu legajo personal. Trata de que sea una foto bien iluminada',
        isOk: 'Sí, quiero actualizar mi foto',
        notOk: 'No, en otro momento'
      },
      country: 'País de residencia',
      state: 'Provincia o estado',
      city: 'Ciudad',
      street: 'Calle',
      number: 'Número',
      flat: 'Piso',
      department: 'referencia al # de departamento',
      neighborhood: 'Barrio',
      block: 'Manzana',
      addressType: 'Tipo de domicilio',
      nameBank: 'Banco',
      cbu: 'CBU',
      typeAccount: 'Tipo de cuenta',
      phone: 'Teléfono fijo',
      cellPhone: 'Teléfono celular',
      contactPerson: 'Persona contacto',
      contactType: 'Tipo de contacto',
      emergencyPhone: 'Teléfono de emergencia',
      cuentaBancaria: 'Número de cuenta bancaria',
      cuentaCci: 'Número de cuenta interbancaria'
    },
    changeAdressWarning:
      'La información proporcionada tiene fuerza de Declaración jurada. Al actualizar los datos firmará el documento, el cual será visible en su bandeja de documentos',
    fieldsError: {
      phone: {
        regex: 'Solo se admite números',
        min: 'No cumple con el mínimo de caracteres'
      },
      phoneEmergence: {
        regex: 'Solo se admite números',
        min: 'No cumple con el mínimo de caracteres'
      },
      celular: {
        regex: 'Solo se admite números',
        min: 'No cumple con el mínimo de caracteres'
      },
      people: {
        regex: 'Solo se admite letras',
        required: 'La persona de contacto es requerida',
        min_length: 'No cumple con el mínimo de caracteres',
        no_only_whitespace: 'No se admiten solo espacios en blanco',
        no_leading_whitespace: 'No se admiten espacios en blanco al principio'
      },
      contactType: {
        regex: 'Solo se admiten letras',
        required: 'El tipo de contacto es requerido',
        min_length: 'No cumple con el mínimo de caracteres',
        no_only_whitespace: 'No se admiten solo espacios en blanco',
        no_leading_whitespace: 'No se admiten espacios en blanco al principio'
      },
      name: {
        required: 'El Nombre es requerido',
        regex: 'Solo se admiten letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      genre: {
        regex: 'Solo se admiten letras',
        required: 'El género es requerido'
      },
      file: {
        format: 'El archivo debe ser un formato de imagen válido',
        size: 'El archivo no puede superar los 2 MB',
        required: 'No se agregó una imagen'
      },
      country: {
        required: 'El país es requerido',
        regex: 'Solo se admiten letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      state: {
        required: 'La provincia o estado es requerido',
        regex: 'Solo se admiten letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      city: {
        required: 'La ciudad es requerida',
        regex: 'Solo se admiten letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      street: {
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      streetVp: {
        required: 'La calle es requerida',
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max:
          'La longitud de la calle es demasiado extensa. Máximo 250 caracteres'
      },
      number: {
        regex: 'Solo se admiten números',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      numberVp: {
        required: 'El número de calle es requerido',
        regex: 'Solo se admiten números',
        min: 'No cumple con el mínimo de caracteres',
        max:
          'La longitud del número de domicilio es demasiado extensa, Máximo 8 caracteres'
      },
      flat: {
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      flatVp: {
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'La longitud del piso es demasiado extensa. Máximo 8 caracteres'
      },
      department: {
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      departmentVp: {
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max:
          'La longitud del departamento es demasiado extensa. Máximo 8 caracteres'
      },
      neighborhood: {
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      neighborhoodVp: {
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'La longitud del barrio es demasiado extensa. Máximo 30 caracteres'
      },
      block: {
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      type_domicile: {
        required: 'El tipo de domicilio es requerido',
        regex: 'Solo se admiten letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      nameBank: {
        required: 'El nombre del banco es requerido',
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      cbu: {
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres',
        is_cbu: 'El número de cuenta no tiene un formato válido',
        cbu_length: 'El número de cuenta debe poseer 22 caracteres'
      },
      typeAccount: {
        required: 'El tipo de cuenta es requerido',
        regex: 'Solo se admiten números y letras',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      cuentaBancariaSueldo: {
        required: 'El número de cuenta es requerido',
        regex: 'Solo se admiten números',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      cuentaSueldoCci: {
        required: 'El número de CCI es requerido',
        regex: 'Solo se admiten números',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres',
        is_cci: 'El CCI no tiene un formato válido',
        cci_length: 'El CCI debe poseer 20 caracteres'
      },
      cuentaBancariaCts: {
        required: 'El número de cuenta es requerido',
        regex: 'Solo se admiten números',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres'
      },
      cuentaCtsCci: {
        required: 'El número de CCI es requerido',
        regex: 'Solo se admiten números',
        min: 'No cumple con el mínimo de caracteres',
        max: 'Se superó el máximo de caracteres',
        is_cci: 'El CCI no tiene un formato válido',
        cci_length: 'El CCI debe poseer 20 caracteres'
      }
    },
    response: {
      success: 'La información se envió correctamente y espera aprobación',
      successCancel: 'La solicitud de aprobación fue cancelada con éxito',
      errors: {
        SYSTEM_API_MIN_LENGTH_VALUE_NOT_REACHED:
          'No se alcanzó el mínimo de caracteres en uno o más campos',
        SYSTEM_API_MAX_LENGTH_VALUE_EXCEEDED:
          'Se excedió el valor de longitud máxima en uno o más campos',
        SYSTEM_API_WRONG_MIME_TYPE: 'Mime Type de imagen incorrecto',
        SYSTEM_API_PARAMETER_ENUM_VALUES:
          'El valor del parámetro no se espera en la matriz de enumeración',
        SYSTEM_API_PARAMETER_REQUIRED: 'Campo requerido no enviado',
        SYSTEM_API_MAX_FILE_SIZE_EXCEEDED:
          'El tamaño de la imagen ha excedido el máximo permitido',
        EXPECTED_PARAMETER_VALUE: 'No se ingresó ningún dato',
        SYSTEM_API_WRONG_DATA_TYPE:
          'Uno o varios datos ingresados no son del tipo correcto',
        SYSTEM_API_PARAMETER_IS_EMPTY:
          'Uno o varios datos ingresados son requeridos',
        SERVICE_UNAVAILABLE_EXCEPTION:
          'Ocurrió un error. Por favor intente nuevamente más tarde',
        UPLOAD_FILE_EXCEPTION: 'La imagen no pudo ser enviada',
        notFound:
          'La solicitud que intentas cancelar no existe o ya fue aprobada',
        SYSTEM_API_PARAMETER_NOT_EXPECTED:
          'Uno o varios parámetros son inválidos',
        ADDRESS_DOCUMENT_USER_PASSPHRASE_NOT_VALID:
          'La contraseña no es valida',
        ADDRESS_DOCUMENT_SIGN_EXCEPTION: 'No se pudo generar la firma',
        ADDRESS_DOCUMENT_DOCUMENT_TYPE_NOT_DEFINED:
          'El tipo de documento no esta definido',
        ADDRESS_DOCUMENT_STORING_EXCEPTION: 'El documento no se pudo guardar',
        ADDRESS_DOCUMENT_TEMPLATE_EXCEPTION:
          'No es posible generar el documento para cambio de domicilio',
        ADDRESS_DOCUMENT_VALIDATION_FAILED: 'Fallo la validacion',
        ADDRESS_DOCUMENT_REQUEST_UPDATE_EXCEPTION:
          'No se puede actualizar la solicitud de cambio de domicilio'
      }
    },
    modal: {
      cancelDialog: {
        title: 'Actualización de datos',
        body:
          '¿Estás seguro que quieres cancelar la solicitud de cambio de información?',
        cancelButton: 'No, cancelar',
        cancelButtonOK: 'Sí, cancelar'
      }
    },
    infoEmployee: {
      tab: {
        personalData: 'Personales',
        contactData: 'Contacto',
        bankData: 'Bancarios',
        salary: 'Evolución salarial',
        identificationData: 'Cómo me identifico',
        addressData: 'Domicilio',
        emptyTab:
          'El Colaborador no ha actualizado su información. Cuando el colaborador actualice su información estará disponible en esta pantalla. ',
        fileNumber: 'Legajo'
      },
      addressInfo: {
        address: 'Domicilio',
        country: 'País de residencia',
        state: 'Provincia / Estado',
        city: 'Ciudad',
        street: 'Calle',
        addressNumber: 'Número',
        floor: 'Piso',
        department: 'Departamento',
        neighborHood: 'Barrio',
        blockStreet: 'Manzana',
        addressType: 'Tipo de domicilio'
      },
      identifyInfo: {
        identifies: 'Cómo me identifico',
        nickName: 'Nickname',
        myGenre: 'Género seleccionado',
        identifyGenre: {
          man: 'Hombre',
          woman: 'Mujer',
          noBinary: 'No binario',
          other: 'Otro'
        }
      },
      personalInfo: {
        personal: 'Personales',
        usuario: 'Usuario',
        nombre: 'Nombre',
        apellido: 'Apellido',
        dni: 'Documento de identidad',
        cuil: 'CUIL',
        cuils: 'CUIL',
        fecha_nacimiento: 'Fecha de nacimiento',
        fecha_contratacion: 'Fecha de ingreso',
        fileNumber: 'Legajo',
        mail: 'Mail',
        orgData: 'Datos de organización',
        sectionCompany: 'Sector',
        locationCompany: 'Locación',
        cargo: 'Cargo',
        reporta_a: 'Reporta a'
      },
      contactInfo: {
        contact: 'Contacto',
        personal: 'Datos personales',
        personalPhone: 'Teléfono fijo',
        cellphone: 'Teléfono celular',
        emergencyData: 'Datos emergencia',
        telephone_emergency: 'Teléfono de emergencia',
        contactPerson: 'Persona de contacto (nombre)',
        contactType: 'Tipo de contacto'
      },
      bankInfo: {
        bank: 'Bancarios',
        nameBank: 'Nombre del banco',
        cbu: 'CBU o alias',
        bankAccountType: 'Tipo de cuenta'
      },
      salaryInfo: {
        salary: 'Evolución del salario'
      }
    },
    emailForm: {
      '00069': 'Ingrese la contraseña requerida para actualizar el email',
      '00070': 'El email a actualizar no ha sido definido',
      '00074': 'El email no es correcto',
      '00071': 'Contraseña incorrecta',
      '00072': 'El usuario no ha sido identificado',
      '00073': 'Usted no tiene permisos para modificar el usuario',
      '00003': 'Token de sesión inválido'
    }
  },
  myTeam: {
    title: 'Mi equipo directo',
    shortName: 'Mi equipo',
    notFound: {
      title: 'Esto es un desierto...',
      description: 'No cuentas con un equipo asociado en este momento',
      caption:
        'Podrás ver tu equipo cuando el administrador actualice la información en el sistema'
    },
    tooltipInfo:
      'El siguiente gráfico representa tu equipo directo, que consiste en los colaboradores que reportan directamente a ti. También permite ver a quien reportas directamente.',
    noFiles: 'No tienes documentos pendientes para firmar',
    signedDocuments:
      'Si quieres consultar un documento firmado puedes cambiar a la pestaña de firmados',
    errorSend: 'Error al enviar los términos:',
    noFilesFound: 'No tienes documentos pendientes',
    added: 'Agregados',
    added2: '{lngt} Agregados',
    addTxt: 'Puedes agregar hasta 100',
    addTxt2: 'separados por comas',
    addTxt3: 'Puedes agregar hasta 100 {dni} separados por comas',
    selectAll: 'Seleccionar todos',
    txtPapa: 'ACA PAPA',
    chartData: 'Presentes,Ausentes',
    desc: 'Descendente',
    asc: 'Ascendente'
  },
  dashboard: {
    hello: 'Hola',
    absences: 'Ausencias',
    myTeam: 'Mi equipo directo',
    members: 'MIEMBROS',
    seeMembers: 'Ver mi equipo',
    pendingFirm: 'Documentos por firmar',
    mine: 'MIOS',
    teams: 'EQUIPO',
    searchDocuments: 'Buscar documentos',
    events: 'Eventos',
    birthday: 'Cumpleaños',
    years: 'Años',
    noEvents: 'Sin eventos',
    uploadLicence: 'Cargar ausencia a colaborador',
    requestSalaryAdvance: 'Solicitar adelanto a colaborador',
    header: 'Solicitar anticipo de sueldo',
    licenseTypeLabel: 'Tipo de licencia',
    colaboratorLabel: 'Buscar colaborador',
    pendingTasks: {
      title: 'Tareas pendientes',
      LICENSES: 'Licencias',
      notFound: 'No tienes tareas pendientes'
    },
    notFound: {
      title: 'Esto es un desierto...',
      description: 'No tienes solicitudes pendientes'
    },
    goBack: 'Volver',
    salaryAdvance: {
      title: 'Anticipo de sueldo a colaborador',
      advanceReason: 'Motivo del anticipo',
      requestMont: 'Monto a solicitar',
      requested: 'Anticipo solicitado',
      expectedDate: 'Fecha prevista',
      btnTitle: 'Solicitar anticipo',
      viewRequests: 'Ver solicitudes',
      seeDetail: 'Ver detalles'
    },
    balanceReport: 'Reporte de saldo de mi equipo',
    sendReminder: 'Enviar recordatorio',
    seeAbsences: 'Ver ausencias',
    LoadAbsences: 'Cargar ausencias'
  },
  salaryAdvanceForm: {
    header: 'Solicitar anticipo de sueldo',
    goBack: 'Volver',
    title: 'Datos del anticipo',
    reason: '¿Cuál es el motivo del anticipo?',
    reasonDescription: 'Indica el motivo por el cual necesitas el anticipo',
    amount: '¿Cuál es el monto a solicitar?',
    amountDescription: 'Ingresa el monto que deseas recibir',
    dateRange: '¿Cuándo quieres recibir el anticipo?',
    dateRangeDescription:
      'Selecciona la fecha en la que esperas recibir la acreditación.',
    dateRangePlannedDateRemember: '¡Recuerda! La fecha efectiva de acreditación del anticipo dependerá de los procesos de cierre de la empresa.',
    btnCancel: 'Cancelar',
    btnLoad: 'Solicitar anticipo',
    reasonLabel: 'Motivo del anticipo',
    amountLabel: 'Monto del anticipo',
    requestUser: '¿Quién recibirá el anticipo?',
    requestUserDescription:
      'Selecciona el colaborador al que vas a asignarle el anticipo',
    requestUserLabel: 'Buscar colaborador',
    modal: {
      requestTitle: 'Solicitar anticipo',
      requestAdvice:
        '¿Estás seguro de que quieres solicitar un anticipo de sueldo?',
      request: 'Solicitar Anticipo',
      cancelAdvice:
        '¿Estas seguro de que quieres salir de la solicitud de anticipo?',
      warning: 'Los cambios realizados no se guardarán',
      confirmCancel: 'Si, salir',
      requestAdviceMessage:
        'Vas a solicitar un anticipo de sueldo, {collaboratorName} con el motivo de {reason}, por un monto total de ${amount} con una fecha prevista de pago {dateSelected}.'
    }
  },
  loadLicence: {
    head: 'Cargar ausencia',
    goBack: 'Volver',
    title: 'Datos de la ausencia',
    licenceColaborator: '¿Quién estara ausente?',
    colaboratorDescription:
      'Selecciona el colaborador al que vas a cargarle la ausencia',
    typeDescription: 'Elige el tipo de ausencia que corresponda',
    licenceType: '¿Cuál es el tipo de licencia que vas a asignarle?',
    amountDescription: 'Ingresa el monto que deseas recibir',
    dateRange: '¿Cuál será el rango de duración de la ausencia?',
    dateRangeDescription:
      'Indica la fecha de inicio y finalización de la ausencia.',
    btnCancel: 'Cancelar',
    btnLoad: 'Solicitar licencia'
  },
  documentsManagement: {
    title: 'Gestión de documentos',
    cards: {
      upload: {
        title: 'Enviar documento',
        subtitle:
          'Envío de documentación puedes enviar Fotos, archivos y formularios'
      },
      certificates: {
        title: 'Solicitar certificados',
        subtitle:
          'Solicita al departamentos de rrhh tus certificados de manera sencilla'
      },
      history: {
        title: 'Historico',
        subtitle: 'Consulta de solicitudes',
        description: 'Consulta el estado de tus documentos y certificados'
      }
    }
  },
  virtualAssistantAI: {
    title: 'Asistente AI',
    text: 'Texto',
    audio: 'Audio',
    termsAndConditionsPrev:
      'Antes de comenzar, es necesario que leas y aceptes los términos y condiciones.',
    termsAndConditionsAccept: 'Acepto los términos y condiciones',
    start: 'Comenzar',
    selectQuestion:
      '¿Qué información del documento quieres consultar? Elige una opción.',
    audioNotSupported: 'Tu navegador no soporta la reproducción de audio.',
    consultAgain: '¿Quieres consultar algo más?',
    moreInformation:
      ' Podemos darte más información sobre estos temas, elige una opción.',
    seeTermsAndCondition: 'Ver términos y condiciones'
  },
  certificates: {
    goBack: 'Volver',
    title: 'Solicitar certificados',
    sections: {
      all: 'Todos',
      moreRequested: 'Los mas solicitados',
      requested: 'Solicitudes'
    },
    cards: {
      all: {
        title: 'Buscar tipo de certificado',
        subtitle: 'Busca y selecciona certificados para solicitar'
      }
    },
    modal: {
      title: 'Solicitar certificado',
      search: 'Selecciona un certificado del listado para poder descargarlo',
      cancel: 'Cancelar',
      download: 'Descargar',
      downloadItem: '¿Estás seguro que quieres descargar {item}?',
      select: 'Selecciona una opción',
      noResultsText: 'No hay resultados de búsqueda',
      notAvailableText: 'No hay certificados disponibles para solicitar'
    },
    error: {
      download:
        'El certificado que intentas descargar no esta disponible o no existe.'
    },
    table: {
      title: 'Certificados solicitados',
      download: 'Descargar'
    }
  },
  modalTimer: {
    title: 'Tu tiempo está por terminar',
    title2: 'Sesión expirada',
    body: {
      textCount: 'Tu sesión se cerrará en:',
      textSeg: 'seg.',
      textExpire: 'Su sesión ha terminado.',
      textExpire2: 'Vuelva a iniciar sesión.'
    },
    buttons: {
      close: 'Cerrar',
      closeSession: 'Cerrar sesión',
      continue: 'Continuar'
    }
  },
  linkUser: {
    linkAccountModal: {
      modalTitle: 'Vincular cuentas',
      title:
        'Detectamos {linkUserCount} cuenta(s) en tu recibo ¿Quieres iniciar la vinculación de tus cuentas?',
      description:
        'Es posible que hayas trabajado con otros empleadores y tengas acceso a múltiples cuentas. Vinculándolas, centralizarás el acceso a toda tu documentación en una sola cuenta.',
      cancelButton: 'En otro momento',
      successOkBtn: 'Ir a vincular cuentas'
    },
    title: 'Vinculación de cuentas',
    titleSection: 'Tus cuentas',
    description:
      'Para validar que esta cuenta te pertenece, es necesario que ingreses tu usuario y contraseña.',
    linkingPageDescription:
      'Para vincular tus cuentas es necesario que ingreses el usuario y contraseña con el que vas poder acceder a todas las cuentas.',
    forgetPassword: 'Olvide mi contraseña',
    notLinked: 'No quiero vincular esta cuenta',
    cancelBtn: 'Cancelar',
    nextButton: 'Siguiente',
    linkAccountBtn: 'Vincular',
    cancelLinkUserModal: {
      modalTitle: 'Salir de vinculación de cuentas',
      title: '¿Estas seguro que quieres salir de la vinculación de cuentas?',
      description: 'Los cambios realizados no se guardarán.',
      cancelButton: 'Cancelar',
      successOkBtn: 'Sí, salir'
    },
    verificationStep: {
      descriptionCodeSent:
        'Para tu seguridad necesitamos verificar tu cuenta de email asociada, por favor ingresa un email válido. Te enviaremos un código que deberás ingresar en el siguiente paso.',
      descriptionCodeNotSent:
        'Para tu seguridad necesitamos verificar tu cuenta de email asociada, por favor ingresa un email válido. Te enviaremos un código que deberás ingresar en el siguiente paso.',
      invalidEmail: 'El correo electrónico no es válido'
    },
    successModal: {
      modalTitle: 'Vinculación finalizada',
      title: 'La vinculación de cuentas fue un éxito ',
      description:
        'Ahora podrás acceder a todas tus cuentas con un solo usuario y contraseña.',
      advice: 'Recuerde usar la nueva contraseña.',
      toHome: 'Ir al home'
    },
    noLinkAccountModal: {
      modalTitle: 'No quiero vincular cuentas',
      title: '¿Estás seguro de que no quieres vincular esta cuenta?',
      description:
        'Al confirmar, no podrás acceder a los documentos de esta cuenta. Selecciona un motivo por el cual no deseas vincularla.',
      firstOption: 'No quiero realizar la vinculación',
      secondOption: 'No soy propietario / Desconozco esta cuenta',
      cancelBtn: 'Cancelar',
      successOkBtn: 'Confirmar'
    }
  },
  workflow: {
    title: 'Consulta de solicitudes',
    table: {
      title: 'Historial de documentos y solicitudes',
      approveBy: 'Aprobado por:',
      rejectedBy: 'Rechazado por:',
      atDay: 'el día',
      comment: 'Comentario:',
      seeDocument: 'Ver documento',
      columns: {
        date: 'Fecha',
        applicant: 'Solicitado por',
        documentType: 'Tipo de Documento',
        status: 'Estado',
        actions: 'Acciones',
        chip: 'workflow'
      }
    },
    status: {
      coursed: 'EN CURSO',
      approved: 'APROBADO',
      rejected: 'RECHAZADO',
      cancelled: 'CANCELADO',
      new: 'NUEVO'
    },
    modal: {
      close: 'Cerrar'
    },
    goBack: 'Volver',
    hideFilters: 'Ocultar filtros',
    showFilters: 'Mostrar filtros',
    digitalForm: 'Datos de formularios digitales',
    sheetResult: 'Resultados a hoja de calculo',
    digitalFormData: 'Descargar datos de formularios digitales',
    allFormResult:
      'A continuación se mostraran todos los formularios que aparecen dentro del resultado de la busqueda.',
    csvFormat: 'Al descargar los datos los obtendra en formato csv',
    templateName: 'Nombre Template',
    downloadData: 'Descargar datos',
    creationDate: 'Fecha de creación',
    period: 'Periodo',
    urlNoValid: 'no es valida la url',
    uploadedError: 'Error en la carga de archivos',
    btnConsult: 'Boton Consulta del Recibo'
  },
  datatable: {
    noDataText: 'Ningún dato disponible'
  },
  at: 'el',
  addFileModal: {
    cancel: 'Cancelar',
    send: 'Enviar',
    success: 'Documento adjunto con éxito',
    close: 'Cerrar'
  },
  sichernConnect: {
    modal: {
      title: 'Vincula tu cuenta con Sichern Connect',
      body: {
        text: 'Asegura tu acceso y simplifica tu inicio de sesión vinculando tu cuenta con Sichern Connect, nuestra plataforma centralizada de autenticación.',
        accept: 'Vincular',
        disagree: 'En otro momento'
      },
      bodyNoEmail: {
        description: 'Solo necesitas hacerlo una vez, y obtendrás:',
        list: {
          item1: 'Mayor seguridad en tu información.',
          item2: 'Acceso simple y rápido'
        },
        noEmailText: 'No pudimos detectar tu correo. Ingresalo para vincular tu cuenta.',
        placeholder: 'Ingresa tu correo *',
        passwordPlaceholder: 'Ingresa tu contraseña',
        errorRequired: 'Este campo es requerido',
        errorInvalid: 'El email no es válido'
      },
      bodyConfirm: {
        description: 'La vinculación se realizará con este correo:'
      },
      notification: {
        successTitle: 'Correo enviado con éxito.',
        successMessage: 'Revisá tu bandeja de entrada para continuar el proceso de vinculación con Sichern Connect desde allí.',
        errorTitle: 'Error al vincular la cuenta.',
        errorMessage: 'Ocurrió un error al intentar vincular tu cuenta. Por favor, intenta nuevamente.',
        infoPasswordTitle: 'Tu contraseña de firma digital venció.',
        infoPasswordMessage: 'Para poder seguir firmando tu documentación, necesitás crear una nueva contraseña.'
      }
    },
    success: {
      title: '¡Vinculación exitosa!',
      button: 'Entendido'
    },
    error: {
      title: 'Error al vincular la cuenta',
      description: 'Inténtalo nuevamente más tarde.',
      button: 'Entendido'
    }
  }
}
